var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoNite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1604 1228",
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,143)",
    d: "m0 0 5 1 17 10 49 28 24 14 42 24 52 30 24 14 26 15 23 13 48 28 28 16 24 14 28 16 19 11 11 7 2 2v205l-16-8-24-13-22-12-29-16-26-14-47-26-28-15-18-10-26-14-18-10-26-14-44-24-15-8-23-13-26-14-22-12-8-4-6 1-23 13-50 28-13 8-19 10-15 9-24 13-17 10-25 14-21 12-10 6-1 51-1 7 15-8 14-9 16-9 24-14 19-11 18-11 18-10 25-15 26-15 44-26 14-8 12-7 5 1 20 10 17 10 8 5-3 3-29 17-19 11-17 10-24 14-26 15-24 14-26 15-15 9-52 30-70 41-22 13-8 4 3 3 25 14 10 6 48 28 26 15 48 28 26 15 48 28 28 16 22 13 28 16 20 12 7 5v2l-21 11-18 10-6 4-5-1-27-15-20-12-29-17-26-15-24-14-21-12-15-9-24-14-26-15-24-14-10-6h-2v61l6 2 13 8 133 76 23 13 26 15 14 8 6 3 4-1 27-14 17-10 19-10 45-25 22-12 58-32 26-14 18-10 26-14 23-13 21-11 23-13 28-15 22-12 26-14 14-8h2v205l-14 9-24 14-23 13-24 14-78 45-22 13-20 11-27 16-23 13-26 15-24 14-27 15-17 10-21 12-26 15-21 12-4 2-7-5-11-6-18-10-24-14-104-60-21-12-24-14-52-30-28-16-52-30-24-14-25-14-25-15-4-3-1-109 4-4 37-17 39-17 24-11 34-15 11-5 1-1v-126l-9-3-30-14-40-18-67-31-3-2v-112l10-6 24-14 26-15 24-14 23-13 24-14 21-12 17-10 25-14 22-13 52-30 24-14 28-16 26-15 22-13 28-16 19-11zm0 56-26 15-17 10-28 16-24 14-21 12-23 13-21 13-11 6-27 15-17 10-21 12-24 14-28 16-24 14-23 13-17 10-15 9-3 2v54l14 7 65 29 20 10h3l1-53 25-14 14-8 23-13 22-13 27-15 21-12 17-10 46-26 24-14 27-15 14-8 7-5 6 2 14 8 29 16 26 14 44 24 12 7 14 7 18 10 46 25 16 9 28 15 18 10 24 13 18 10 24 13 22 12 12 7h3v-95l-9-6-24-14-28-16-24-14-26-15-28-16-24-14-26-15-28-16-17-10-26-15-24-14-28-16-26-15-24-14-9-5zm405 360-1 4 3 3v-7zm1 132-2 2 1 7 2-2v-7zm-677 53-40 17-30 13-17 7-10 4-2 2v56l19 11 24 14 26 15 23 13 13 8 21 12 26 15 29 17 78 45 24 14 16 9 13 8 28 16 29 17 4 1 27-16 24-14 22-13 14-8 26-15 24-14 28-16 22-13 28-16 29-17 23-13 20-12 23-13 27-16 23-13 9-5 2-2v-95l-5 1-26 14-21 12-23 12-10 6-12 6-23 13-28 15-46 25-29 16-26 14-16 9-32 17-23 13-28 15-18 10-5 3-4-1-27-15-24-14-25-14-17-10-20-11-24-14-28-16-23-13-21-12-23-13-26-15-8-5-1-51z",
    fill: "#AE5FF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,143)",
    d: "m0 0 5 1 17 10 49 28 24 14 42 24 52 30 24 14 26 15 23 13 48 28 28 16 24 14 28 16 19 11 11 7 2 2v205l-16-8-24-13-22-12-29-16-26-14-47-26-28-15-18-10-26-14-18-10-26-14-44-24-15-8-23-13-26-14-22-12-8-4-6 1-23 13-50 28-13 8-17 9-1-2 5-5 12-4 8-5 1-3 10-5 1-2 8-5 1-2 7-2 1-2h2l-2-3-12 4-4 2-4-1-4 1 3-3 5-3h3v-2h3l1-4-3-5-6 2h-3l1-5 2-4 5-1v-2l5-4h2l2-5 7-7 3-1v-3l5-2h3l-4-1-25 13-19 11-8 3v-2l-4-1 24-14 25-14 24-14 18-10 7-5 6 2 14 8 29 16 26 14 44 24 12 7 14 7 18 10 46 25 16 9 28 15 18 10 24 13 18 10 24 13 22 12 12 7 3 1-1-95-25-15-28-16-52-30-24-14-21-12-24-14-23-13-27-16-25-14-15-9-28-16-24-14-28-16-17-10-9-5-5 1-27 16-49 28-22 13-12 3-7 5h-2v2h-6v2h-2v2l-4 1-14 9h-2v2l-11 4-2 3-5 2-6 4h-2l-1 3-5 1-4 3-2-1 4-4-1-2 5-4 2-7 6-3 2 1v-3l16-8h4v-2l5-3 6-1 2-4 10-5 5-1v-2h3v-2l5-1v-2l8-5 5-2 4-3h3v-2l7-4 6-3h2l2-6h-2-2l1-4h2v-2h2v-4l-3-1 4-8h2v-3h2v-2l4-1 7-8h2v-2l7-2v-2l6-4 4-5 12-6 12-7-4 1-7 2-12 7-16 8-15 9-7 2-6-1 4-3 29-17 28-16 19-11zm405 416-1 4 3 3v-7z",
    fill: "#708BF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1222,665)",
    d: "m0 0h2v205l-14 9-24 14-23 13-24 14-78 45-22 13-20 11-27 16-23 13-26 15-24 14-27 15-17 10-21 12-45 26-6 1-1-4-6-1v-2l-5-1-18-10-11-6-5-4-22-12-3-2v-2l-5-1-9-5-16-9-3-3 5 1 9 4 10 5v2l3-1 3 4h2v2l6 2h2v2l6 2h2v2l4 1v2l3-1 1 2h3l2 2v-4l-4-2-7-3v-2l-5-2v-2l-6-2v-2l-4-1 4-1v-2l-5-1 1-3-4-1v-2l-3-1v-2l-4-2-2-5-3-1 4-1-3-6-2-2-1-5 5 2 6 2 3-2-5-2-5-3-4-4-3-1-5-5h-3l-1-1-7-4v-2l-3-1-5-5 1-2 2 1v-2l-4-2v-2l-5-2-1-2 5 2 28 16 16 9 13 8 28 16 29 17 4 1 27-16 24-14 22-13 14-8 26-15 24-14 28-16 22-13 28-16 29-17 23-13 20-12 23-13 27-16 23-13 9-5 1-1 1-95-16 8-22 12-18 10-28 15-22 12-29 16-26 14-23 13-21 11-23 13-21 11-16 9-32 17-23 13-28 15-18 10-5 3-4-1-27-15-24-14-25-14-17-10-20-11-24-14-28-16-23-13-35-20 4-1 12 7 10 5 24 14 9 5 20 11 3 1 2 3 14 7 7 4 11 4 10 6 10 4 3 3 4 2h2v2h3v2h5v2l4 1 7 4 5 3 7 2 1 4h4v2l5 1 1-2h-3l-4-4-2-4-4 1v-2l-3-1v-2l-5-2-10-6 1-2-2-1-2-5-7-8v-5l-5-5-3-5 1-4 6 1 2 1 1-2-1-4-3 1-5-5-10-5-5-3v-2l-3 1v-2l-5-2-4-3v-2l3-1-5-5 2-1 25 14 24 14 25 14 24 14 15 8 4-1 27-14 17-10 19-10 45-25 22-12 58-32 26-14 18-10 26-14 23-13 21-11 23-13 28-15 22-12 26-14zm-14 26-2 2 1 7 2-2v-7z",
    fill: "#7ED8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(547,645)",
    d: "m0 0 9 3 6 3 1 2 5 1 8 4 2 2 4 3 10 4 5 1 1 3 6 2 9 5v2l3-1 4 2 1-4 5 3 4 1 5 6 8 3 4 3h2l3 3v2l5 1 1 2 5 1 1 3 11 3 9 1 24 14 26 15 41 24 28 16 22 13 28 16 20 12 7 5v2l-21 11-18 10-6 4-5-1-27-15-20-12-29-17-26-15-24-14-21-12-15-9-24-14-26-15-24-14-10-6h-2v61l6 2 13 8 77 44 10 6 5 5 2 3h-3-2l4 4 8 4 4 4 5 2 10 6 4 2 4 5-3 1h-3l-6-1 1 4 4 6 3 3 1 7 6 6v2l2 1-1 2 3 1 1 3 12 7 3 3v2l4-1 3 3v2l3 1v2h3l-1 3-5-2v-2h-4l-3-4-9-3-6-4-6-3v-2l-3 1-2-1v-2h-3v-2l-3 1-6-4v-2l-9-2-10-7-6-2-12-5-2-2-5-2-9-5-1-3-5-1-18-10-11-6-26-15-11-6-7-4-7-2-20-11-19-11-2-2v-51l-48 20-25 11-17 7-10 4-1 1v56l15 8 10 6 24 14 26 15 19 11 17 10 21 12 26 15 22 13 52 30 17 10 4 4 6 5v2l-2 1 7 6 3 3h2l1 2h3l-1 2 3-1 4 3 1 3 4 1 4 3 2 1v2l5 2 2 1-1 2-2 1-6-2-4-2 2 5 3 5v2l-3 1 3 3 6 7 2 1v2l4 1v2l4 2v2l-3 1 3 1v2l4 1 2 1v2l5 2v2l4 1 7 4 1 4h-3l-5-3h-2v-2l-4-1v-2l-3 1-5-3v-2l-3 1-5-3v-2l-3 1-3-4h-2v-2l-7-2-5-3-7-3h-2l12 7 11 6 7 3v2l5 2 23 13 10 7 28 14 5 2v4l4-1-3 3-7-4-23-13-52-30-24-14-28-16-24-14-23-13-17-10-104-60-28-16-45-26-21-12-23-14-1-1-1-109 2-2 1 93h1l1 13 3 3v2l4 2 1 2 7 3 7 5 3 1v2l7 2 4 3 7 3 8 4v2l4 2 6 2v2l7 2 16 10 6 3 9 5 10 6 11 6 16 9 7 4 12 6v2l12 6 8 3 1 2 2-1 1 4h4l5 5 6 2 5 3 12 6v2l6 2 7 2 1 3 4-1 3 1 2-1-2-2-4-1v-2l-5-2-18-9-4-4h-3v-3l-5-2-8-4-2-3-6-2-3-3v-2h-5l-4-3v-2l-6-2-5-2v-2l-8-2-4-4h-3v-2l-9-3v-2l-5-2-2-2-5-1-3-4h-4v-2l-5-2-3-1v-2l-4-1-10-5-3-3-14-7-3-2v-2h-5l-4-4-9-4-11-6-6-3-1-3-5-2-1 2-3-4-7-3-6-3-2-4v-8l-1-3 1-3-1-9v-38l-1-18v-13l1-4 5-2v-2l16-6 21-9 15-7 16-7 13-6 8-3 10-5h3v-2l20-9 3-3 5-1 7-5h2l1-4 3-3h2l-1-5 1-5v-22l-1-3v-3l1-4v-5z",
    fill: "#AE5FF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(867,195)",
    d: "m0 0 5 1 9 5 35 19 17 10 11 6 9 6 11 6 19 11 26 16 3 1 1 2 14 7 15 9 8 5 12 6 8 5 18 10 16 10 8 4 19 11 14 8 38 22 22 13 6 4 1 2v123l-1 52-5-1-22-12-19-10-23-13-13-7-11-6-10-6-14-7-7-4-13-8-20-11-6-3-42-22-7-4-11-6-20-11-16-8-17-10-13-8-6-3v-2l-6-2-15-9-4-2v-3l-5-2-2-1v-2l-4-2-4-3v-2l-4-1-5-7-2-8-1-5 8 1 5 3 7 1 4 3 4 1v2l4 1 7 4 17 8 12 7 16 8 10 6 11 7 16 8 23 13 11 6 15 8v2l5 1 10 6 14 7 10 6 11 6 19 10 25 14 19 10 14 8 11 6 13 7h2v-120l-8-7-43-25-12-7-16-9-19-11-18-11-22-13-20-11-16-9-18-10-15-9-18-10-7-4-18-10-13-8-9-6-6-3-1-2-10-5-5-3-6-4-5-5-9-6-5-5-2-5v-7-3l-2-1v-3zm340 364-1 4 3 3v-7z",
    fill: "#7ED8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(652,238)",
    d: "m0 0 3 1-1 3-3 1-5 5-9 3-2 3-6 2v2l-8 2v2l-7 2-6 3-4 4-5 3-3 3-6 2-1 3-11 6-7 4-1 2-5 2h-3v2l-6 1v2l-10 5h-4l-1 4-6 2-1 2h-6v2l-7 4-1 2-12 6h-2v2l-5 1-3 3-3 1-2 3-6 1-1 3-7 2-1 2-5 1-2 2-6 4-6 3-1 2-8 2v2l-5 1v2l-6 2-1 2-7 3-2 2-6 2-1 2-5 3-5 2-6 3-5 1v2l-5 1v6l-1 6 1 22 1 18v10l1 15-1 2 1 6-1 12 2 4 10 5 13 5 10 4v2l8 1 2 2 6 2 5 3 10 4 11 5 8 4 5 2 16 8 20 9 18 8v2l3 1 1 2v10l2 9v18l2 7 5-1 3-2h3l1-3 6-3h2v-2l13-5 13-8h2v-2l8-4 5-1v-2l7-5 5-1-10 10-3 4-1 3 3-1-1-2 6-1 9-5 3-1 3-3 14-8 3-1 1-2 6-2 1-2 14-7 3-2h4v-2l6-1-5 4-18 10-24 14-26 15-22 13-39 23-8 4 3 3 25 14 10 6 48 28 26 15 24 14 5 3-4 2-9-3-5-2-2-3-5-1v-2l-5-1v-2l-10-4v-2l-8-2-4-5v-2l-6-1-3-2-1 4-5-2h-2v-2l-4-1-11-6-3-3-6-1-10-5-3-2v-2l-7-2-3-1v-2l-5-1-12-6h-2v7l-1 5 1 9v19l-1 7-2 2-3 1-1 4-6 4-5 3h-5l-1 3-13 6-4 2h-3v2l-12 5-5 3-13 5-11 5-20 9-16 7-9 4-14 5h-2v2l-5 2v25l1 10v40l1 9-1 2 1 3v7l1 4 6 2 8 4 2 3h4l4 4 5 1v2l6 2 11 6 4 2v2l8 2v2l5 2 15 8 3 3 7 3 4 2v2l5 1 4 3 4 1 2 4h6l4 4 2 1v2h5l5 5 2-1 4 3v2h6v2h2v2l7 2 4 2 4 4 5 1v2l3 1v2l3-1v2l4 1 2 3 7 3 5 3v3l3-1 7 6 9 4 11 6v2l5 1 2 3-5 1-5-1-3-3-7-1-4-3v-2l-7-2-9-5-6-3-6-4v-2h-4l-2-2-4-3-6-2-6-3-6-4v-2l-4-1-14-7-10-6-12-7-6-3-10-6-9-5-11-6-11-7-7-3v-2l-6-1-4-3v-2l-7-2-4-3-7-3-8-4v-2l-5-1-8-6-5-2-7-8-2-10h-1v-98l19-9 36-16 32-14 35-16 24-10 2-2v-126h-2l-3-3-3-1v-2l-5-1v-2l-6-2-10-4-18-8-4-3-22-10-8-5-4-1v-2h-3l-1 2-11-5-1-2-5-2-8-4-10-4-14-7v-3l-4-2-4-7-1-10v-90l2-3 9-2v-2l6-2v-2l5-1 3-2h2l1-2 5-3 4-1 7-5 1-2 5-1 3-2h2l1-2 7-2 2-2h4l1-3 11-6h3l1-3 6-2 2-2h4v-2l12-7h3l1-3 6-2 10-7 10-5 2-2 5-2 8-5 6-3 1-2h4v-2l4-3h3v-2l4-4 6-1 1-3 4 1 1-2 6-2 3-2h4v-2l7-5 7-3 8-5 9-5 17-9 7-5 8-1h2z",
    fill: "#A449DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1042,763)",
    d: "m0 0 7 1 5 3-1 4-15 9-3 3-16 9-16 8-17 9-16 8-10 6-10 5-21 12-16 9-13 8-16 8-4 1v3l-11 7 1 4 4 2 1 8 5-2 6-3 7-1 5-4 7-4 5-2 11-5 4-2h3l1-3 6-2 11-6 7-3 11-7 8-4 22-12 7-5 7-3 3-2 9-3 14-7 9-3 2 1 1-3h6v2l9-3 4-1v4l-26 14-22 12-24 13-23 13-19 10-22 12-18 10-32 17-23 13-28 15-18 10-5 3-4-1-27-15-24-14-25-14-17-10-20-11-24-14-28-16-23-13-35-20 4-1 12 7 10 5 24 14 9 5 20 11 3 1 2 3 14 7 7 4 11 4 10 6 10 4 3 3 4 2h2v2h3v2h5v2l4 1 7 4 5 3 7 2 1 4h4v2l5 1 1-2h-3l-4-4-2-4-4 1v-2l-3-1v-2l-5-2-10-6 1-2-2-1-2-5-7-8v-5l-5-5-3-5 1-4 6 1 2 1 1-2-1-4-3 1-5-5-10-5-5-3v-2l-3 1v-2l-5-2-4-3v-2l3-1-5-5 2-1 25 14 24 14 25 14 24 14 15 8 4-1 27-14 17-10 19-10 45-25 22-12 58-32 26-14 18-10z",
    fill: "#707FEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1057,915)",
    d: "m0 0h5l-2 1-2 4-1 1-4 5-14 9-4 4-11 6-17 10-11 6-17 9-12 7-18 10-9 6-13 8-8 5h-3v2l-6 3-9 6h-2v2l-7 3-2 3h-2l-2 4-5 1v2l-3 1-2 9 6 2 4 1v-2l9-3 5-1 5-3 12-5 8-4 1-2 5-2 4-2 6-1v-2l11-6 4-2 3-3 14-7 11-7 5-1v-2l11-6 7-5 9-5 4-2 7-2 9-4h3l1-2 5-1 5-2 5 1 5-3 7-1-2 5-16 9-42 24-22 13-25 14-17 10-24 14-27 15-17 10-21 12-45 26-6 1-1-4-6-1v-2l-5-1-18-10-11-6-5-4-22-12-3-2v-2l-5-1-9-5-16-9-3-3 5 1 9 4 10 5v2l3-1 3 4h2v2l6 2h2v2l6 2h2v2l4 1v2l3-1 1 2h3l2 2v-4l-4-2-7-3v-2l-5-2v-2l-6-2v-2l-4-1 4-1v-2l-5-1 1-3-4-1v-2l-3-1v-2l-4-2-2-5-3-1 4-1-3-6-2-2-1-5 5 2 6 2 3-2-5-2-5-3-4-4-3-1-5-5h-3l-1-1-7-4v-2l-3-1-5-5 1-2 2 1v-2l-4-2v-2l-5-2-1-2 5 2 28 16 16 9 13 8 28 16 29 17 4 1 27-16 24-14 22-13 14-8 26-15 24-14 28-16 22-13 28-16 20-12 2 1-1 2 8-4 7-3z",
    fill: "#707EEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,382)",
    d: "m0 0 2 1v3h-2l-1 3-7 1-2 4-11 7-5 3h-2l-1 4-10 6-10 3-3 4h-2l-2 4-43 24-49 28-19 11-1 51-1 7 15-8 14-9 16-9 24-14 19-11 18-11 18-10 25-15 26-15 44-26 14-8 12-7 5 1 20 10 17 10 8 5-3 3-29 17-19 11-17 10-24 14-26 15-24 14-26 15-15 9-9 5-7 1v2l-7 3-11 6h-3l-2 4h-5l-1 3-12 6-5 3h-2l-1 3-5 2-7 4-4 2-4 1 1-5 5-6 8-6 4-1 1-2-2-1h4v-2l4-1v-2h3l1-2 5-3 5-2h3v-2l10-5 5-2v-2l5-2h3v-2l6-3h2v-2l7-2v-2h2v-2h3v-2l5-2 3-2h4l1-3 3-2h4v-2l7-4 4-2 1-3h-1-3l1-5 3-8 3-1v-2h-2v-2l-2-1 2-1v-3l3-2 5-1 1-4-10 5-6 4h-3v2l-8 4h-4v2l-6 3-1 2-6 1v2l-12 6-16 10h-2v2l-9 3-1 3h-2v2l-9 2-10 5-7 1v-2l-9 5-14 8-8 3-8 7-5 1v-2h-2l1-11h1v-5l-2-3-1-8 1-9-1-6v-15l3 1 1-8 10-7 13-7 8-5 5-3h4v-2l-7 2-1-5 6-4h2v-2l5-1v-2l4-2v-2l5-3h3l1-2h2l3-3 7-4h3v-2l8-3 15-8 2-3 7-1v-2l9-5 11-6 4-4 4-1 10-6h2v-2l9-2 1-2 10-3z",
    fill: "#7280F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,143)",
    d: "m0 0 5 1 17 10 49 28 24 14 42 24 52 30 24 14 10 6-4 2 2 4 2 1-2 2-4 1-11-5-19-11-26-16-11-6-9-6-11-6-20-11-12-7-12-6-12-7-5-3h-7v3l3 1 1 4-1 3v5l2 1v2l5 5 10 6 4 5 9 5 8 5 4 2v2l5 1 6 5-2 1-9-4-3 1-6-1-5-2v-2l-3 1-5-3-4-1v2l4 1 16 9 7 5 11 6 14 8 2 3-5-2-16-9-24-14-28-16-26-15-24-14-9-5-5 1-27 16-49 28-22 13-12 3-7 5h-2v2h-6v2h-2v2l-4 1-14 9h-2v2l-11 4-2 3-5 2-6 4h-2l-1 3-5 1-4 3-2-1 4-4-1-2 5-4 2-7 6-3 2 1v-3l16-8h4v-2l5-3 6-1 2-4 10-5 5-1v-2h3v-2l5-1v-2l8-5 5-2 4-3h3v-2l7-4 6-3h2l2-6h-2-2l1-4h2v-2h2v-4l-3-1 4-8h2v-3h2v-2l4-1 7-8h2v-2l7-2v-2l6-4 4-5 12-6 12-7-4 1-7 2-12 7-16 8-15 9-7 2-6-1 4-3 29-17 28-16 19-11z",
    fill: "#717FEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,677)",
    d: "m0 0 5 3 4 1 5 6 8 3 4 3h2l3 3v2l5 1 1 2 5 1 1 3 11 3 9 1 24 14 26 15 41 24 28 16 22 13 28 16 20 12 7 5v2l-21 11-18 10-6 4-5-1-27-15-20-12-29-17-26-15-24-14-21-12-15-9-24-14-26-15-24-14-10-6-3-1v16l-2 7v22l2 17 1 3-5-2-2-14 1-23-1-6 1-24 3-2 5 1 4 2v2l4 1h3l8 5h4l5 2 5 1 8 4 7 3v3l3-1 1 2h4v2l6 1 2 1v2l6 2 8 4v2l6 2 11 7 8 4 3 1 2 3 10 5 5 2v2l5 2v2l6 1 1 3 5 1 11 6 4-1-8-4v-2l-5-2-5-3-3-3-3-2v-2l4-2 2 1-2-8-3-5 3-1 10 4 2-1 1 3v-3l-11-5-5-5-1-2-6-2-11-6-4-2-5-5-4-2v-2h-2l-2-2-6-3-4-1v-3l-4-1-10-4-2-1-2-3-7-1-1-2-4-1-5-3-4-1-4-2v-2h-3l-2-5-2-1-1-4z",
    fill: "#707EEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1021,271)",
    d: "m0 0h6l25 14 27 16 23 13 17 10 26 15 23 13 17 10 26 15 11 7 2 2v205l-16-8-24-13-22-12-29-16-26-14-47-26-28-15-36-20-3-3-9-5-2-5 9 1 14 7 17 7-3-3 5 1 12 7 12 6 22 12 10 6 11 6 14 8 8 4 11 6 16 9 44 24 17 9 10 5v-175l-4-4-28-16-19-11-22-13-18-10-13-8-11-6-19-11-10-6-22-12-25-15-8-4 2-1 6 2 4-2-2-3-3-2z",
    fill: "#2FB3FC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(883,241)",
    d: "m0 0 6 1 4 2h2v2l5 1 7 1 2-1 19 8 9 6 12 7 6 3 7 4 10 6 12 6 13 8 18 10 10 6 11 6 13 7 24 14 26 16 18 10 16 9 15 9 28 16 9 7 3 3v120l-3 1-21-12-12-6-12-7-16-8-23-13-19-10-14-8-16-9-11-6-7-3v-2l-6-2-11-6 3-4-1-3-5-3-7-4v-4l-4-2-5-2-6-2-6-3-3-2v-2l-5-1-4-4h3l27 14 21 12 30 16 18 10 24 13 18 10 24 13 22 12 12 7 3 1-1-95-25-15-28-16-52-30-24-14-21-12-24-14-23-13-27-16-14-8-5-5-18-10-18-11-9-5-4-2z",
    fill: "#2FB3FC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,536)",
    d: "m0 0 23 10 22 10 3 3v138l-14 8-25 11-8 4h-1z",
    fill: "#A44ADE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1222,665)",
    d: "m0 0h2v205l-14 9-24 14-23 13-24 14-52 30-21 12-3-1 2-2-9 3-2 1-6-1h-2l-1 2-9 3-10 5h-4v-2l7-3 4-4 16-8 5-4 5-2 14-8 6-3 10-6 11-6 7-4 2-2 5-2 12-7 15-9 12-6 5-4 8-4h3v-2l12-6 4-3 12-6 13-8 1-177-18 10-17 10-17 9-22 12-19 11-16 8-19 11-20 11-16 9-8 4-2-1 7-5 9-5v-3h-3l-1-2h-6l1-3 21-11 23-13 21-11 23-13 28-15 22-12 26-14z",
    fill: "#2DB2FC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(864,358)",
    d: "m0 0 8 1 5 3 7 1 4 3 4 1v2l4 1 7 4 17 8 12 7 16 8 10 6 11 7 16 8 23 13 11 6 15 8v2l5 1 10 6 14 7 10 6-2 1-10-4-1 2h2l2 5 4 5-1 2-3-1 3 10 4 2 4 4 6 3 1 2-5-1-23-13-6-3-42-22-7-4-11-6-20-11-16-8-17-10-13-8-6-3v-2l-6-2-15-9-4-2v-3l-5-2-2-1v-2l-4-2-4-3v-2l-4-1-5-7-2-8z",
    fill: "#8EB6FE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(867,195)",
    d: "m0 0 5 1 9 5 35 19 17 10 11 6 9 6 11 6 19 11 26 16 3 1 1 2 14 7 15 9 8 5 12 6 8 5 7 4-1 2-14-7h-3l1 5v4l2 7-1 2 2 1 5 5 10 6 7 4v2l2 1-5-1-9-6-24-14-20-11-16-9-18-10-15-9-18-10-7-4-18-10-13-8-9-6-6-3-1-2-10-5-5-3-6-4-5-5-9-6-5-5-2-5v-7-3l-2-1v-3z",
    fill: "#8EB6FE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1183,727)",
    d: "m0 0h5v121l-5 5-15 9-24 14-25 14-21 12-13 8-10 6-13 8-22 12-2-1 13-9h2l2-6 2-2h2l1-2-4 1-10 5-7 2 3-5 18-10 28-17 22-12 17-10 24-14 16-9 8-5 1-95-16 8-22 12-18 10-28 15-22 12-5 2-2-2-6 3h-5v-2l-6 1-1 2-4 1-9 3-16 8-2-1 10-6 5-1v-2l15-8 11-6 25-13 22-12 18-10 10-6 14-7 23-13z",
    fill: "#2BB2FC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1081,757)",
    d: "m0 0 4 1-6 3h-2v2l-8 5h-2v2h-3l-2 4 1 1 2 5-2 3 1 3 6-2 2 1-4 5-20 11-17 9h-2v2l-14 7-10 6-7 3-8 5-10 6-18 9-5 4-7 4-8 3-8 5-5 1-1 2-11 5-7 3-8 4-9 6-7 1-9 5-3-1v-8l-6-2 1-5 9-6h2v-3l15-8 12-6 13-8 18-10 19-11 10-5 16-9 16-8 17-9 14-7 19-10 16-9z",
    fill: "#8ABEFE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1065,958)",
    d: "m0 0 2 1-2 4-16 9-42 24-22 13-25 14-17 10-24 14-27 15-17 10-21 12-45 26-6 1-1-4-6-1v-2l-5-1-18-10-11-6-5-4-22-12-3-2v-2l-5-1-9-5-16-9-3-3 5 1 9 4 10 5v2l3-1 3 4h2v2l6 2h2v2l6 2h2v2l4 1v2l3-1 1 2h3l2 2v-4l-4-2-7-3v-2l-5-2v-2l-6-2v-2l-4-1 4-1 8 5 14 7 13 8 5 2 6 4 11 6 4 3 10 1v-2l8-4 4-1v-2l8-4 9-6h3v-2l11-6 13-8h4v-2l10-6 3-3 8-4 8-5 7-4 12-5 8-4 1-2 5-2 4-2 6-1v-2l11-6 4-2 3-3 14-7 11-7 5-1v-2l11-6 7-5 9-5 4-2 7-2 9-4h3l1-2 5-1 5-2 5 1 5-3z",
    fill: "#717EEF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1085,909)",
    d: "m0 0h2v2l-11 7-10 6-6 3-2 4 1 3 7 1 2 2 4-1 5-3 4 1-3 1-2 4-5 4-12 7-6 3-10 6-11 6h-2l-1 3-7 2v2l-8 4-7 4-9 6-7 4h-2v2l-7 3-9 6-14 7h-2l-1 3-12 7h-3v2l-7 3-5 2h-3l-1 3-10 5-13 5-4 3-5 1-7 1v2l-5 1-3-3-2-1v-6l1-4 3-1 1-2 6-2 5-6 4-2h3v-2l11-7 6-2v-2l11-6 13-8 19-12 12-6 4-3 11-6 12-6 9-5 25-15 16-8 11-7 11-6z",
    fill: "#8ABEFE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1042,763)",
    d: "m0 0 7 1 5 3-1 4-15 9-3 3-16 9-16 8-17 9-16 8-10 6-10 5-21 12-16 9-13 8-26 13-22 12h-3v2l-16 8-5 3-7 4-6 2-7 4-8-1-10-4-10-6v-2l-5-1-3-1v-2h-3l-1-2-3-1v-2h-4v-2l-7-2-5-3v-2l-8-2-1-4-7-2-8-6v-2l-3 1-5-5-10-5-5-3v-2l-3 1v-2l-5-2-4-3v-2l3-1-5-5 2-1 25 14 24 14 25 14 24 14 15 8 4-1 27-14 17-10 19-10 45-25 22-12 58-32 26-14 18-10z",
    fill: "#717EEF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(889,1023)",
    d: "m0 0 2 1-3 1-2 4-5 1v2l-3 1-2 9 6 2 4 1v-2l11-3-4 4-8 5h-3l-1 3-9 5-3 1v2l-7 3-11 7h-3l-1 2-3 2h-3v2l-11 6-6 4h-3v2l-9 5h-3v2l-6 1-5-2-10-6-9-5-2-2-7-3-10-6-17-9-5-3v-3l-5-1 1-3-4-1v-2l-3-1v-2l-4-2-2-5-3-1 4-1-3-6-2-2-1-5 5 2 6 2 3-1 4 1 11 7 7 4 5 4 10 5 5 3 1 2 11 6 9 5 8 5h3l9-4 34-20 11-6 13-8 12-6z",
    fill: "#9A8AFA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(717,862)",
    d: "m0 0 6 1 2 1 1-2 14 6 1 4 5 1 3 1v2l4 1 8 4v2h4v2l4 1v2h3v2l5 1 3 1 1 2 11 6 11 4 7-1 6-4 9-3 16-9 5-3h3v-2l16-8 9-5 6-2v2l-11 7 1 4 4 2 1 8 5-2 6-3h5l-4 3-6 2v2h-5v2l-12 7-8 5h-3v2l-5 2h-3v2l-7 3-5 3h-3v2l-14 8-8 4-8-1-5-2-7-4v-2l-5-1-16-9-7-4v-2h-5l-8-5-5-2v-2l-5-1-4-3-2-5-7-8v-5l-5-5-3-5z",
    fill: "#9A8AFA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,258)",
    d: "m0 0 3 1-21 12-26 15-11 7-11 6-27 15-17 10-21 12-24 14-28 16-24 14-23 13-17 10-15 9-2 1v54l4 2 5 5 4 1v3l6 2 3 3h-2v2l-5-1-5-2 1 2-5-1-4-2-5-2v-2l-4-1v-2l-3-1-3-5-2-10v-24l1-8h2l-1-10 1-11 3-3 8-4 1-2h3v-2l8-3 16-9 16-8 5-4 5-2 10-6 5-4h3l1-3 8-4 8-5 5-3h3l1-2h3v-2l4-2h4l1-3 5-3 2 1v-2l5-3 6-2 2-2h3v-2h4l1-3 4-3h6l2-4 2 1 1-2 8-2 1-3 6-2 2-2 5-2 3-3 5-2 3-3h2v-2h5l-2 5-4 4 1 2-4 1 1 2 6-4h3l3-3 7-5h4l2-4 7-3h4v-2l9-6 7-4 2-1 2 1v-2h2v-2l4-1 2 1v-2l9-6z",
    fill: "#A34ADD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(801,185)",
    d: "m0 0h6l5 2 1 2 12 6 11 6 6 4 10 6 11 6 11 7 16 8 10 6 9 5v2l5 1 6 5-2 1-9-4-3 1-6-1-5-2v-2l-3 1-5-3-4-1v2l4 1 16 9 7 5 11 6 14 8 2 3-5-2-16-9-24-14-28-16-26-15-24-14-9-5-5 1-27 16-49 28-22 13-12 3-7 5h-2v2h-6v2h-2v2l-4 1-14 9h-2v2l-11 4-2 3-5 2-6 4h-2l-1 3-5 1-4 3-2-1 4-4-1-2 5-4 2-7 6-3 2 1v-3l16-8h4v-2l5-3 6-1 2-4 10-5 5-1v-2h3v-2l5-1v-2l8-5 5-2 4-3h3v-2l7-4 6-3h2v-2l6-3 14-8 9-6 6-3h2v-2l8-4h3v-2l12-6 12-8z",
    fill: "#6E72ED"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(801,348)",
    d: "m0 0h5l10 6 15 7 7 3 22 12 8 5 7 4 8 3v2l4 1 8 4 15 9 6 3v2l6 2 20 12 18 10 19 10 11 6 15 8 14 8 5 5-5-1-18-8-10-5-8-1 1 4 5 2 7 4-2 1-26-14-46-25-22-12-15-8-23-13-26-14-22-12-8-4-6 1-23 13-50 28-13 8-17 9-1-2 5-5 12-4 8-5 1-3 10-5 1-2 8-5 1-2 7-2 1-2h2l-2-3-12 4-4 2-1-3 5-2h3v-2l5-3h3l1-3 6-2 3-3 5-2 1-2 8-2v-2l12-6 8-5z",
    fill: "#707EEF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(800,159)",
    d: "m0 0h8l4 1 3 3 1 2 5 2 8 4 7 4 4 1 3 3 2 1v2l5 1 7 4 3 1 1 2 7 4-1 2h-3v3l3 1 1 4-1 3v5l2 1v2l5 5 10 6 3 4-6-1-4-3-9-5-12-7-7-4-8-5-11-6-14-8-4-2v-2l-11-1-8 4-13 8-6 3h-2v2l-8 4h-3v2l-11 6-14 9-6 3-5 1 1-3h-2-2l1-4h2v-2h2v-4l-3-1 4-8h2v-3h2v-2l4-1 7-8h2v-2l7-2v-2l7-4 6-4 6-3 16-9 11-6z",
    fill: "#9A8AFA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,382)",
    d: "m0 0 2 1v3h-2l-1 3-7 1-2 4-11 7-5 3h-2l-1 4-10 6-10 3-3 4h-2l-2 4-43 24-49 28-19 11-1 51-1 7 15-8 14-9 16-9 24-14 19-11 18-11 14-8 9-3 5-1h2l8-2v-2l14-8 5-2h3v-2l3-2 6 1-4 4-10 3v5l-17 9-6 4h-3v2l-8 4h-4v2l-6 3-1 2-6 1v2l-12 6-16 10h-2v2l-9 3-1 3h-2v2l-9 2-10 5-7 1v-2l-9 5-14 8-8 3-8 7-5 1v-2h-2l1-11h1v-5l-2-3-1-8 1-9-1-6v-15l3 1 1-8 10-7 13-7 8-5 5-3h4v-2l-7 2-1-5 6-4h2v-2l5-1v-2l4-2v-2l5-3h3l1-2h2l3-3 7-4h3v-2l8-3 15-8 2-3 7-1v-2l9-5 11-6 4-4 4-1 10-6h2v-2l9-2 1-2 10-3z",
    fill: "#7E65E7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(800,323)",
    d: "m0 0h8l9 4 11 6 15 8 8 4 8 5 13 6 1 2 8 4-4 1-8-4h-4l1 4 2 9 5 6 3 1 5 5 3 2v2l5 2 2 1v2l-5-2-3-1v-2l-5-1-7-3-10-6-17-10-6-3-9-4-17-8-6-4-7 1-9 5-10 6-4 2h-3v2l-5 1-1 2-2-1-1 3-5 2-4 3-5 2-1 2-5 3h-3v2l-10 4-5 1 3-3 5-3h3v-2h3l1-4-3-5-6 2h-3l1-5 2-4 5-1v-2l5-4h2l2-5 11-7 7-4 9-5h4v-2l10-5h3l1-3z",
    fill: "#9A8AFA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,728)",
    d: "m0 0h9l1 2v13l1 5 1 6-1 5v29l4 4 12 5v2l5 1 2 1v2l3 1 6 4 5 2 7 6 7 3 19 10v2h3v2h4v2l4 1-4 1-8-4-10-4-7-1-9-6-4-2-9-4-7-4v-2l-4-2-8-3-7-4-4-4v-2l-7-1-3-5-1-6-2-40-12 6-64 27-19 8-8 3 1 57 2 1v2l4 1v4l2 1-2 2-6 1-3-3v-2l-5-1-6-13v-25l1-13 1-7v-4l1-9h3v-2l5-4 13-5 8-3h4v-2l13-5 7-2 2-2 6-1 1-2 9-3 12-5 12-6 2-2 12-3 3-1v-2z",
    fill: "#A44ADD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(783,163)",
    d: "m0 0 4 1-7 5-6 3-13 7-2 4-5 3h-2v2l-4 2h-3v2l-5 2-16 8-9 5-4 1v2l-6 2-1 2-7 2v2l-5 2-3 3-10 5h-2v2l-9 5h-3v2l-7 4-3 1v-3l-5 2-8 1-12 8-16 8-6 4-10 6-7 3-4 2v2l-7 3-1 1h-5l-1 3-1-2-6 5-4-1-2 4h-2v2l-5 3h-2v2h-4l-1 3-6 3-9 6-5 2-4 3-7 3-5 4-10 5-15 9h-2v2l-5 2-6 3-5 3-11 6-1 2-5 2-3 2h-5l-1 3-4 1-4 2-2-1-1 3-9 6-4 2h-3l-1 3-4 1-4 2-2-1v2l-3 2h-3v2l-3 2-6 1-1 2v90l1 11 5 7 2 1v3l5 2 9 4 11 5 7 3 6 3v2l4 1 7 3 4-1v2l5 1 11 6 8 4 10 4 7 5 6 2 10 5 11 4 4 2v2l5 1v2l5 1 1 2-9-3-28-13-40-18-67-31-3-2v-112l10-6 24-14 26-15 24-14 23-13 24-14 21-12 17-10 25-14 22-13 52-30 24-14 42-24h8l9-4 25-14 11-6 6-3z",
    fill: "#AC63F2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(717,746)",
    d: "m0 0 10 3h3l3 3 4-1 2 2 2 1v2h3l1 2 7 4 4 2v2l5 1 3 1v2l6 2 3 2v2h3v2l6 2h2l1 2 4 1 3 2v2h4v3h5l3 2v2l6 1 3 3 6 2v2l5 2 8 4 1 2 7 3 1 2 7 4 2 4 2 1h-2l-1 4-8 4h-4v2l-3 1-6-2-8-5-14-7v-2l-5-1-2-2-1-2-5-1-11-6-4-2v-2l-5-2-8-5-22-11-3-2v-2l-3-1 2-1-8-4v-2l-5-2-5-3-3-3-3-2v-2l4-2 2 1-2-8-3-5z",
    fill: "#9A8AFA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(429,552)",
    d: "m0 0 5 1 1 3h2l1 4h5l6 11 1 2v12l-3 15v29l-1 9 1 17v11l-1 16-2 7-5 5h-2l-1 2-5 4-5-2v-2l-2-1-1-9v-23l-1-4 2-16v-50l-1-10-1-27 4-2h3z",
    fill: "#AF5FF2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(827,418)",
    d: "m0 0h5l8 4 5 4v2h2l1 3-5 1-1 4-6 4h-3v2l-6 3-6 4-4 1-5 4h-3v2h-4v2l-12 6h-4l-1 3-6 3-5 1-1 3h-3v2l-4 1-4 4-7 3-5 4-12 6-5 4h-3v2h-4v2l-5 2 1-3h-1-3l1-5 3-8 3-1v-2h-2v-2l-2-1 2-1v-3l3-2 5-1 2-5 6-4h3l1-3 11-6h2v-2l7-3 7-2v-2l11-6 4-3 6-1 1-3 9-5 6-3 5-2 5-4z",
    fill: "#9A8AFA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,677)",
    d: "m0 0 5 3 4 1 5 6 8 3 4 3h2l3 3v2l5 1 1 2 5 1 1 3 11 3 9 1 24 14 26 15 41 24 28 16 7 5 1 4 4 2 2 2 12 6 3 3v2l4 1 2 2 5 1v2h3v2l4 1 7 4v3h3v6l-5 4-5 2-7 3-8 4-6-2v-1h8v-2l8-3 4-2 1-4-5-5-5-3v-2l-4-1-4-2v-2l-5-1-11-7-4-2v-2l-8-2v-2l-8-2v-3h-4l-2-2-3-2-3-1v-2l-3 1-5-3v-2h-3l-4-4h-3v-2h-2v-2l-8-2v-2l-4-1-8-5v-2h-3l-1-2-2 1-1-4h-4l-1-2-11-5-5-5-1-2-6-2-11-6-4-2-5-5-4-2v-2h-2l-2-2-6-3-4-1v-3l-4-1-10-4-2-1-2-3-7-1-1-2-4-1-5-3-4-1-4-2v-2h-3l-2-5-2-1-1-4z",
    fill: "#7280EF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(974,814)",
    d: "m0 0 2 1-9 6h-2v2l-8 5-4 5-5 4 1 4 7 1 4-1 5 2 6-2 2 1-4 3-7 3-5 4-7 4-8 3-8 5-5 1-1 2-11 5-7 3-8 4-9 6-7 1-9 5-3-1v-8l-6-2 1-5 9-6h2v-3l15-8 12-6 13-8 18-10 19-11 10-5z",
    fill: "#8EA4FD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(867,195)",
    d: "m0 0 5 1 9 5 35 19 17 10 11 6 9 6-3 1-10-5-8-3 4 7 2 2 3 10 9 7 4 7 8 4 10 7 2 3-5-2-13-7-4-3-11-6-12-7-13-8-4-3-3-1-1-2-10-5-5-3-6-4-5-5-9-6-5-5-2-5v-7-3l-2-1v-3z",
    fill: "#8EA4FD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1042,763)",
    d: "m0 0 7 1 5 3-1 4-15 9-3 3-16 9-16 8-17 9-16 8-10 6-10 5-21 12-11 6-7 1-4-3-7 3h-3l-2 4-7 1 1-2h2v-2h4l2-5 27-15 24-13 23-13 28-15 22-12 18-10z",
    fill: "#5093F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(986,965)",
    d: "m0 0 2 1-9 6-12 7-9 8-4 2-2 6-4 1 1 3 4 1 1-1 13-2 5-2 8-1 4-1-4 4-11 6-10 5h-2l-1 3-12 7h-3v2l-7 3-5 2h-3l-1 3-10 5-13 5-4 3-5 1-7 1v2l-5 1-3-3-2-1v-6l1-4 3-1 1-2 6-2 5-6 4-2h3v-2l11-7 6-2v-2l11-6 13-8 19-12 12-6 4-3z",
    fill: "#8EA4FD"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1062,803)",
    d: "m0 0h3v4l-26 14-22 12-24 13-23 13-19 10-22 12-10 3-6 4-7 2 1-4 4-3-4-1v-2l8-6 9-4 2-2h4v-2l4-1 1-3 11-6 7-3 11-7 8-4 22-12 7-5 7-3 3-2 9-3 14-7 9-3 2 1 1-3h6v2l9-3z",
    fill: "#5294F9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1065,958)",
    d: "m0 0 2 1-2 4-16 9-42 24-22 13-25 14-17 10-7 4h-6l-5 4-9 3v-3l1-3-5 1 3-5 6-1v-2l7-4 4-2 5-5h4v-2l11-6 4-2 3-3 14-7 11-7 5-1v-2l11-6 7-5 9-5 4-2 7-2 9-4h3l1-2 5-1 5-2 5 1 5-3z",
    fill: "#5394F9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(579,700)",
    d: "m0 0 5 1 4 2v2l4 1h3l8 5h4l5 2 5 1 8 4 7 3v3l3-1 1 2h4v2l6 1 2 1v2l6 2 8 4v2l6 2 11 7 8 4 3 1 2 3 10 5 5 2v2l5 2v2l6 1 1 3 5 1 11 6 5 1v2l10 4 1 3 8 5v2l6 2 6 4 1 2-12-2-6-3-9-4v-2h-2v-2l-4-1-7-3-9-5-6-3v-2h-2v-2l-8-1-14-8-6-2-20-12-10-5v-2l-4-1-7-4-19-11-9-3-24-14-10-6-3-1v16l-2 7v22l2 17 1 3-5-2-2-14 1-23-1-6 1-24z",
    fill: "#7F64E7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(864,358)",
    d: "m0 0 8 1 5 3 7 1 4 3 4 1v2l4 1 7 4 17 8 12 7 16 8 10 6 5 4-4-1-9-4-8-3-10-4 1 4 4 10 11 9v2h2l5 6v2l5 2 12 8-2 1-16-8-19-11-13-8-6-3v-2l-6-2-15-9-4-2v-3l-5-2-2-1v-2l-4-2-4-3v-2l-4-1-5-7-2-8z",
    fill: "#8EA4FD"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(760,338)",
    d: "m0 0h4v2l-5 2h-3v3l-7 6-3 3-11 5h-2v2l-5 2-3 3-7 3-11 6h-3l-1 3-6 2-4 3-5 1v2l-12 6-6 4h-2v2l-7 2v2l-4 3-11 3v2l-8-1-4 1-19 9-4 4-5 2-5 3-8 4-4 4-16 8-13 6-9 6-9 3v2l-3 2-1 7-1 23-1 8v11l-1 2-2-1 1-53 24-14 39-22 22-13 27-15 21-12 17-10 18-10h6 3l16-8 16-9z",
    fill: "#7E64E7"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1057,915)",
    d: "m0 0h5l-2 1-2 4-1 1-4 5-14 9-4 4-11 6-17 10-11 6-17 9-12 7-18 10-9 6-7 4-7 2-8 5-2-1v-2l-8 1 1-4 9-4 4-3 7-3 10-7 5-3 5-5 28-16 15-9 28-16 20-12 2 1-1 2 8-4 7-3z",
    fill: "#5295F9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(805,361)",
    d: "m0 0 12 4 14 6 4 2v2l4 1 8 4 4 1v2l5 1 1 2 6 2 6 3h2l5 5 9 4 4 3 5 2 14 3v2l4-2 5 3 7 3 6 2 26 15 23 12 11 6 15 8 14 8 5 5-5-1-18-8-10-5-8-1 1 4 5 2 7 4-2 1-26-14-46-25-22-12-15-8-23-13-26-14-22-12-11-5z",
    fill: "#5596F9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,742)",
    d: "m0 0h1l2 43 2 5 1 3 7 2v2l4 2 1 2 6 3 9 4 6 5 22 11 7 4 7 1 12 5 8 4 3 2 8 1 9 6 8 4 3 1v2l5 2 10 6 6 3 3 3 4 1v2l4 1 3 1v2l10 3 5 4 5 1v2l4 1 5 3v2l11 3 2 4 12 7 3 3v2l4-1 3 3v2l3 1v2h3l-1 3-5-2v-2h-4l-3-4-9-3-6-4-6-3v-2l-3 1-2-1v-2h-3v-2l-3 1-6-4v-2l-9-2-10-7-6-2-12-5-2-2-5-2-9-5-1-3-5-1-18-10-11-6-26-15-11-6-7-4-7-2-20-11-19-11-2-2-1-52z",
    fill: "#7E64E7"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(635,408)",
    d: "m0 0h8l1 2-4 2-1 2h-4v2h-2v2l-8 2v2l-11 4h-2v2l-10 5h-2v2h-3v2l-10 5-5 2v2l-5 1v3l-8 2v2l-11 6-5 3h-2v2l-3 3-1 23 1 12-2 8 2 1h-2v8l-2 7-1 1h-6l-4-1v-2l-7-2v-2h-5l-5-2-8-4-3-1v-5l-4-4-9-4-1-4 11 4v2l5 1 11 5 9 3 8 2v-13l1-8 1-25 2-6 3-1v-2l7-3 8-5 3-3h3l6-3h2l1-2 9-4 5-2 2-2h3l2-4h2l1-3h2l7-3 2-2 5-2 5-4 17-8z",
    fill: "#A449DD"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(384,759)",
    d: "m0 0h1l1 93h1l1 13 3 3v2l4 2 1 2 7 3 7 5 3 1v2l7 2 4 3 7 3 8 4v2l4 2 6 2v2l7 2 16 10 6 3 9 5 10 6 11 6 16 9 7 4 12 6v2l12 6 8 3 1 2 2-1 1 4h4l5 5 6 2 5 3 12 6v2l6 2 7 2 2 4 7 2 1 5 11 6 10 6 6 3v2l5 1 2 1v2l7 2 9 6 14 7 23 14 9 5 14 7v2l5 2 23 13 10 7 28 14 5 2v4l4-1-3 3-7-4-23-13-52-30-24-14-28-16-24-14-23-13-17-10-104-60-28-16-45-26-21-12-23-14-1-1-1-109z",
    fill: "#A96DF4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(883,241)",
    d: "m0 0 6 1 4 2h2v2l5 1 7 1 2-1 19 8 9 6 12 7 6 3 7 4 10 6 12 6 13 8 18 10 10 6 7 7-5-1-10-4-7-3-1 2v-2l-10-1 17 10 4 4-5-2-23-13-24-14-26-15-5-3-5-5-18-10-18-11-9-5-4-2z",
    fill: "#5294F9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(759,488)",
    d: "m0 0 4 1-2 3-4 1-5 4h-2l-5 4-1 2-6 2-5 4-2 2h-3l-1 3h-2l-2 4h-2l-2 4-16 9-17 10-9 2v2l-7 3-11 6h-3l-2 4h-5l-1 3-12 6-5 3h-2l-1 3-5 2-7 4-4 2-4 1 1-5 5-6 8-6 4-1 1-2-2-1h4v-2l4-1v-2h3l1-2 5-3 5-2h3v-2l10-5 5-2v-2l5-2h3v-2l6-3h2v-2l7-2v-2h2v-2h3v-2l5-2 3-2h4l1-3 3-2h4v-2l7-4 3-2 2 1 1-3 9-3 10-5 7-3 1-2z",
    fill: "#7F64E7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(886,197)",
    d: "m0 0h5l4 3 4 1 1 2 7 3 9 5 6 1 1 3 4 2v2l6 2 3 2 6 1v2h3v2l6-1 28 16 27 16 19 11-4 2 2 4 2 1-2 2-4 1-11-5-19-11-26-16-11-6-9-6-11-6-20-11-12-7v-2l-4-2-3-1-1-2-3-1-1-5z",
    fill: "#5193F9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,382)",
    d: "m0 0 2 1v3h-2l-1 3-7 1-2 4-11 7-5 3h-2l-1 4-10 6-10 3-3 4h-2v2l-8 3h-3l-2 4-7 3h-3v2l-21 10-11 7h-4v2l-10 6-4 2-10 2-1-5 6-4h2v-2l5-1v-2l4-2v-2l5-3h3l1-2h2l3-3 7-4h3v-2l8-3 15-8 2-3 7-1v-2l9-5 11-6 4-4 4-1 10-6h2v-2l9-2 1-2 10-3z",
    fill: "#7E64E7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(757,213)",
    d: "m0 0 3 1-3 3h-2v2h-3v3l-4 1v3l-5 2-6 4h-4l-1 3-10 7-6 4-5 3-3 4-7 4-8 3-7 4-5 2v2h-6v2h-2v2l-4 1-14 9h-2v2l-11 4-2 3-5 2-6 4h-2l-1 3-5 1-4 3-2-1 4-4-1-2 5-4 2-7 6-3 2 1v-3l16-8h4v-2l5-3 6-1 2-4 10-5 5-1v-2h3v-2l5-1v-2l8-5 5-2 4-3h3v-2l7-4 6-3h2v-2l6-3 4-1 7-1v-2l9-4 5-3h2z",
    fill: "#7E63E7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,306)",
    d: "m0 0 6 2 8 5 3 6 5 1v3l4 1 5 5 1 2h-2v2l-9-2-12-6-3-1h-8l-9 4-1 2-10 5h-3v2l-7 3-6 3-3 3-7 3-3 2-3-1 6-5h2v-3l5-2h3l-4-1-25 13-19 11-8 3v-2l-4-1 24-14 25-14 24-14 18-10z",
    fill: "#7481F0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(615,996)",
    d: "m0 0 9 1 10 5v2l4-1 9 4 9 5 2 4 5 1 7 5 12 6 3 3 11 5v2h2v2l3-1 3 1v2h2v2h6v2l4 2 3 1v2l5 1 9 5 2 3 3 1v2l4 1 2 1v2l5 2v2l4 1 7 4 1 4h-3l-5-3h-2v-2l-4-1v-2l-3 1-5-3v-2l-3 1-5-3v-2l-3 1-3-4h-2v-2l-7-2-5-3-7-3-8-3-21-12-11-6-8-4v-2l-7-2v-2l-6-2-10-6-11-6-1-4-5-2-3-3z",
    fill: "#7F63E7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,198)",
    d: "m0 0h9l1 3h7l4 3 7 2h3l1-4 5 3 10 4 35 20 12 6 5 4 8 4v2l5 1 6 5-2 1-9-4-3 1-6-1-5-2v-2l-3 1-5-3-4-1v2l4 1 16 9 7 5 11 6 14 8 2 3-5-2-16-9-24-14-28-16-26-15-24-14-12-6z",
    fill: "#717EEF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,450)",
    d: "m0 0h4v2l-5 1v2l-7 5 1 3 6-1v2l-7 3-7 4-5 3-16 9-4 3-2 8h-2v18l1 5-1 10 2 6h1v7h-1l-2 10h2v2l8-4 5-5 10-4 12-7 7-4 3 1 11-2-4 3-5 4-4 2h-3v2l-6 2-1 2-7 2v2l-20 10-5 2h-7l-1-2v-15l-1-13-1-7 2-19-1-5v-13l4-6 3-2h3l1-3 7-5 16-8 4-1v-2h4l1-3h3v-2h4z",
    fill: "#A349DD"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(930,1023)",
    d: "m0 0 3 2-9 6h-3v2l-6 2-1 3h3l1 4h-3l1 1 9-3 6-4 3 2-15 9-27 15-17 10-21 12-19 11v-3l2-3 5-2 8-5 7-4 3-3h3v-2l4-4 1-5-3 3-4 1-7 4-10 4-6 2-1 3-5 2-3 2-4-1 11-6 2-2h3v-2l11-6 13-8h4v-2l10-6 3-3 8-4 8-5 7-4 12-5 8-4 1-2z",
    fill: "#708CF3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(783,163)",
    d: "m0 0 4 1-7 5-6 3-13 7-2 4-5 3h-2v2l-4 2h-3v2l-5 2-16 8-9 5-4 1v2l-6 2-1 2-7 2v2l-5 2-3 3-10 5h-2v2l-9 5h-3v2l-7 4-3 1v-3l-5 2-4-1 5-5 6-2 6-4h2l2-5 5-2v-2l7-2v-2h5l2-4 11-6h2l1-4 18-10h8l9-4 25-14 11-6 6-3z",
    fill: "#7F64E7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1012,281)",
    d: "m0 0 9 1 16 9 13 8 12 6 8 5 7 4-1 2-14-7h-3l1 5v4l2 7-1 2 2 1 5 5 10 6 7 4v2l2 1-5-1-9-6-24-14-11-6-4-4-4-3 2-1-4-4v-2h-2l-6-12-3-4v-4h-3z",
    fill: "#88C9FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(910,370)",
    d: "m0 0 9 3 10 6 24 12 10 2 12 7 1 3 7 3v2l4 2 7 3 9 3 4 3 1 4 6 3 7 5-2 4-3 1-10-5-22-13-16-8-13-8-11-6-19-10-5-3v-3l-4-1-5-3z",
    fill: "#5093F9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1022,444)",
    d: "m0 0h6l4 2 9 3 32 18-2 1-10-4-1 2h2l2 5 4 5-1 2-3-1 3 10 4 2 4 4 6 3 1 2-5-1-23-13-6-3-15-8v-2h3l-6-8-4-9-4-6z",
    fill: "#88C9FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(929,864)",
    d: "m0 0h5l-4 2v2l-5 2-14 8-4 2 5 2-5 5v2l7-3 7-4h5l-4 3-26 14-28 15-18 10-29 16-10 5 2-4 7-4h2l1-3 8-4h2v-2h4v-2l5-2h3v-2l6-3 10-6 5-5 6-2v-3l4-2h-3l-9 3-15 8h-4v-2l4-2h4v-2l11-6h2l1-2 7-4h2v-2l3-1 2 1v-2l6-3 10-6 8-5 5-2 11-5 4-2h3z",
    fill: "#6F8BF3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(692,423)",
    d: "m0 0 3 1-15 9-24 13-17 10-25 14-21 12-10 6-1 51-1 7 15-8 14-9 16-9 24-14 19-11 11-7 2 1-7 7h-4l-2 4h-6l-1 4h-5l-1 4-3 1-3-1v2h-2v2l-3 1-4 4-4-1v3l-4 2-3-1v2l-3 2h-4l-1 3-7 1-2 6-13 7-8 3-8 7-5 1v-2h-2l1-11h1v-5l-2-3-1-8 1-9-1-6v-15l3 1 1-8 10-7 13-7 8-5 5-3h4v-2l12-6 5-2v-2l7-3 14-8 12-6h3v-2l10-4 2-3z",
    fill: "#A76AF3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(821,153)",
    d: "m0 0 14 7 17 10 21 12 24 14 42 24 10 6-1 2h-3v-2h-3v-2h-6l-9-5v-2l-5-2-1-2-7-2-11-6-4-2v-2l-6-1-2-2h-3l2 3-1 3 4 1v2l4 1 3 3-4-1-8-4-12-7-11-6-5-3v-2l-6-1-6-4-3-1v-2l-5-2 1-2h5v3l6 1h3l2 1v-2l-5-2-15-8-3-1-5-5v-2l-6-2-2-3z",
    fill: "#6F8BF3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(798,353)",
    d: "m0 0h8l10 4 9 5-1 2-4 1-4-1v-2l-5-1-4-2-5 1v2l-4-1-2 6-23 13-21 12-25 14-13 8-17 9-1-2 5-5 12-4 8-5 1-3 10-5 1-2 8-5 1-2 7-2 1-2h2l-2-3-12 4-4 2-1-3 5-2h3v-2l5-3h3l1-3 6-2 8-3 7-4 7-1v-2l10-4 2-2 5-1 1-3z",
    fill: "#6E71EC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(988,426)",
    d: "m0 0 13 1 12 7 11 6 10 5-1 2-4-1-7-2 3 7 3 4 3 8 5 6v2l-5 1-25-13-7-4-4-2 1-3 6 3-8-7-3-5 1-7 1-1-5-5z",
    fill: "#8ABEFE"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(999,958)",
    d: "m0 0 2 1-1 4-4 8h9l9 1-2 2-10 5h-3l-1 3-8 4-12 7-2 3-5 1-9 2-8 1-2 1-4-2v-3l4-1 1-6 11-8 6-5 17-10 1-2z",
    fill: "#8EB7FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1081,757)",
    d: "m0 0 4 1-6 3h-2v2l-8 5h-2v2h-3l-2 4 1 1 2 5-2 3 1 3 6-2 2 1-4 5-20 11-15 8-7 1-3-12 6-7 5-2v-2l-2-1 10-6 3-3 17-9 10-6z",
    fill: "#88CAFF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,976)",
    d: "m0 0 2 1-4 4-6 3-10 7-5 2-6 4-6 1 1 3h6l2 2 4-2 2-2 4-2 3 1-12 8h-3v2l-6 3-9 6h-2v2l-16 8-15 8-6 4-3-1h2v-2l7-4 1-2 8-4 1-3 5-1 5-3 5-1v-2l9-5 1-4-7 3-6 3v2l-6 1-3 3-5 3h-3l-1 2-2-1v2l-17 10h-3v2l-10 5-7 3h-2l-2 3h-2v2l-5 2-3 1-1 2-5 4-6-1-4 1 5-4 16-9 25-15 26-15 13-8 18-10 24-14z",
    fill: "#728EF4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 802)",
    d: "m0 0 2 1-5 4-4 6 2 4 5 6-5 4-11 5-9 5-5 3-5 2-1 2-5-2-9 1-4-3 1-4 7-6 5-5 5-2v-2l10-6 3-3 5-3 2 1-3 3 11-6z",
    fill: "#8EB7FE"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(810,783)",
    d: "m0 0 10 5 48 28 11 7 1 3-21 11-18 10-6 4-5-1-27-15-45-27 2-1 11 6 11 7 7 3 4 3 7 2 8 5 11 6 4 3 8 2 1 2 6-2 11-6 1-2 6-3 2-5v-3l2-7h-3l-1-3-10-5v-2h-3l-2-2-4-1-5-3v-2l-3-1v-2l-4-1-8-4-3-3-5-3z",
    fill: "#738EF4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,382)",
    d: "m0 0 2 1-3 7-7 3-13 7-12 7h-2l-1 3-19 9-4 4-5 2-5 3-8 4-4 4-16 8-13 6-9 6-9 3v2l-3 2-1 7-1 23-1 8v11l-1 2-2-1 1-53 24-14 39-22 22-13 27-15 21-12z",
    fill: "#AC64F3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,688)",
    d: "m0 0 7 3 1 2 10 4 14 8 4 4h3v2l3 1-4 2-3-2-5 1v-2l-5-2-4-3-2 1-4-2v-2l-9-2-2 1-1 26 1 8-1 22 2 11 11 6 7 5 4 4 5 1 1 4-4 1-8-5-8-4-5-2-3-2v-2h-3l-3-5 1-2-2-1-1-10v-31l2-18-2-15z",
    fill: "#A449DD"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,258)",
    d: "m0 0 3 1-21 12-26 15-11 7-11 6-27 15-17 10-21 12-24 14-28 16-24 14-23 13-17 10-15 9h-2v-2l4-1v-2l8-4h3v-2l4-3 5-2 8-5h3l2-4 7-3 5-3 2 1v-2l9-5h3v-3l21-11 3-1 4-4 17-9 5-3 11-7 13-7 10-7h3v-2l6-1v-2l9-6 6-3 2-2 5-2 12-6h3l3-3 7-5h4l2-4 7-3h4v-2l9-6 7-4 2-1 2 1v-2h2v-2l4-1 2 1v-2l9-6z",
    fill: "#AB66F3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,268)",
    d: "m0 0h7l7 2 11 6 1 2 7 3-1 2-6-1 1 3h3l2 6 3 3 4 9v2h2l2 5 3 1-1 2 6 4-2 1-11-6-19-11-6-4-1-4-2-4-4-2-4-6v-2h2l-1-6-1-4z",
    fill: "#8ABEFF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(822,450)",
    d: "m0 0 3 1-4 4-2 3-2-1-1 3-4 1v2l-5 3-5 2-3 3-5 1-2 4-6 3h-4l-2 5-6 3-2 4-26 15-24 14-1-2 6-5 1-2 5-3 4-4 7-1 2-4 5-4h2l6-4 3-1-3-1h-6l-1 3-7 3-10 5-6 2v-2h4v-2l7-4 8-5 8-4 5-4 10-3 6-3 11-6 7-4 5-2 2-2 5-2 9-6h4v-2z",
    fill: "#7073ED"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1085,909)",
    d: "m0 0h2v2l-11 7-10 6-6 3-2 4 1 3 7 1 2 2 4-1 5-3 4 1-3 1-2 4-5 4-12 7-6 3-10 6-9 2 2-3h3v-2h3v-3l-10-2-1-2 1-4-2-2 7-5 3-3 18-10 17-10z",
    fill: "#88C9FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(825,409)",
    d: "m0 0h2l-1 4h2l-1 3-10 4h-3l-1 2-7 5-6 3h-3v2l-6 3-5 7-10 5-3 1v2l-8 4-6 1v2l-13 7-1 2-4-1 1-3 11-5v-2l-6 1v2l-9 4-11 6h-2v2l-8 2-1 2-5-1-5 3-3-1 29-17 10-6 11-1 12-6h2v-2l11-6 9-6 8-4h2l-1-3 9-3 1-2h3v-2l10-5h2l1-2z",
    fill: "#7174EE"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(699,1049)",
    d: "m0 0 5 1 9 4 10 5v2l3-1 3 4h2v2l6 2h2v2l6 2h2v2l4 1v2l3-1 1 2h3l2 2v-4l-4-2-7-3v-2l-5-2v-2l-6-2v-2l-4-1 4-1 8 5 14 7 5 5 9 5v2l5 1 4 2 3 3h2l3 3 6 5-1 2 4 2h3l5-2 8-4 4-1-1 4-6 4-4 2h-3v2h-10v-2l-5-1-18-10-11-6-5-4-22-12-3-2v-2l-5-1-9-5-16-9z",
    fill: "#707EEF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,385)",
    d: "m0 0 1 2v90l1 11 5 7 2 1v3l5 2 9 4 11 5 7 3 6 3v2l4 1 7 3 4-1v2l5 1 11 6 8 4 10 4 7 5 6 2 10 5 11 4 4 2v2l5 1v2l5 1 1 2-9-3-28-13-40-18-67-31-3-2v-25l1-86z",
    fill: "#AC63F2"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,204)",
    d: "m0 0h2v2l-10 6-4 2-1 2h-5v2l-3 2h-4v2l-5 3v2h-2v2l-12 7-6 2v2l-8 4-9 6-16 8-6 4-10 6-7 3-4 2v2l-7 3-1 1h-5l-1 3-1-2-6 5-4-1-2 4h-2v2l-2-1-1-3 21-12 24-14 52-30 24-14z",
    fill: "#A965F2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(553,634)",
    d: "m0 0 5 2 35 20 46 27 26 15 17 10-4 2-9-3-5-2-2-3-5-1v-2l-5-1v-2l-10-4v-2l-8-2-4-5v-2l-6-1-3-2-7-1-3-4v-2l-6-1v-2l-4-1-7-3-6-6-6-3v-2l-5-1-10-7-6-3-7-4z",
    fill: "#AB67F3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,677)",
    d: "m0 0 5 3 4 1 5 6 8 3 4 3h2l3 3v2l5 1 1 2 5 1 1 3 11 3 9 1 36 21-2 2-6-2v-2h-2v-2l-2 1 2 6h3 5l-1 5-2 1v-2l-6-2-11-6-4-2-5-5-4-2v-2h-2l-2-2-6-3-4-1v-3l-4-1-10-4-2-1-2-3-7-1-1-2-4-1-5-3-4-1-4-2v-2h-3l-2-5-2-1-1-4z",
    fill: "#7E63E7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,536)",
    d: "m0 0 18 8v2l-12-2-4-1 1 16h1v34l-1 4-1 45 3 1 1 4-3 3 1 11-1 5v15l-1 26 3 2v2h3l1 5-8 4h-1z",
    fill: "#AF5FF2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,979)",
    d: "m0 0 5 1 12 7 9 5 10 6 6 3 14 8 16 9 4 2v2l5 1 2 1v2l7 2 9 6 14 7 23 14 9 5 14 7v2l5 2 23 13 10 7 28 14 5 2v4l4-1-3 3-7-4-23-13-52-30-24-14-28-16-24-14-23-13-17-10-26-15-7-4z",
    fill: "#998DFB"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(688,829)",
    d: "m0 0 6 2 24 14 6 4v2l10 5 1 5 6 2 6 3v2h7l3 6h2l3 4-1 2-4-3-8-1v-2l-8-2-1-4-7-2-8-6v-2l-3 1-5-5-10-5-5-3v-2l-3 1v-2l-5-2-4-3v-2l3-1-5-5z",
    fill: "#6E72ED"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,820)",
    d: "m0 0 5 1 8 4 20 11 17 10 9 5 20 11 3 1 2 3 14 7 13 8 7 4 9 5 14 8 12 6 14 8 3 1v2l5 2 12 7 8 6-2 1-25-14-24-14-27-15-24-14-28-16-23-13-26-15-16-9z",
    fill: "#998DFB"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(689,997)",
    d: "m0 0h5l9 6 3 1v2l6 2 3 2v2l4 1 11 5 5 2 3 3 11 6v3l12 6v3l-2 1-7-1-13-8-5-2-1-2-10-5-7-6-3-1-5-5h-3l-1-1-7-4v-2l-3-1-5-5z",
    fill: "#6E72ED"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(734,896)",
    d: "m0 0 8 2v2l5 1 8 5 5 1 4 4 14 7 5 6 4 2 1 2 5 2v2l5 2 4 2 1 2 4-1 1-3h3v5h-2v2h-2v2l-7-1v-2l-7-2-8-5-15-8-3-1-1-2-4-2 3-3h-3l-4-4-2-4-4 1v-2l-3-1v-2l-5-2-10-6z",
    fill: "#6E71ED"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(579,700)",
    d: "m0 0 5 1 4 2v2l4 1h3l8 5v3l6 2 4 3v3l5 2 4 4-6-2-22-13-10-6-3-1v16l-2 7v22l2 17 1 3-5-2-2-14 1-23-1-6 1-24z",
    fill: "#8263E8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(692,423)",
    d: "m0 0 3 1-15 9-24 13-17 10-25 14-21 12-10 6-1 51h-1l-1-53 10-7 13-7 8-5 5-3h4v-2l12-6 5-2v-2l7-3 14-8 12-6h3v-2l10-4 2-3z",
    fill: "#A76EF5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(680,542)",
    d: "m0 0 3 1-23 13-24 14-26 15-22 13-39 23-3 1v-2h2l2-4h2v-2l9-4 8-5 3-1 3-3 10-6 8-4 4-3 7-4 7-3-1-2 6-1 9-5 3-1 3-3 14-8 3-1 1-2 6-2 1-2 14-7 3-2h4v-2z",
    fill: "#AB64F2"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,742)",
    d: "m0 0h1l2 43 2 5 1 3 7 2v2l4 2 1 2 6 3 9 4 6 5 22 11 7 4 1 2 5 3 1 2-5-2-15-8-7-4-7-2-20-11-19-11-2-2-1-52z",
    fill: "#A86DF4"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(682,988)",
    d: "m0 0 5 2 28 16 16 9 13 8 28 16 29 17 2 2-5-1-11-4v-2l-5-2-8-4v-2h-4v-2l-4-1-4-2v-2l-5-1-11-7-11-6v-2l-5-1-15-7-3-3-6-3v-2l-4-1-13-8-1-3-5-2z",
    fill: "#9790FB"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(751,788)",
    d: "m0 0 16 8 6 4 5 3 2 5 9 6 7 3v2l5 2 6 3 5 4 7 3-2 2-5-2h-3l-5-2-9-5-5-4-7-3-18-9v-2l-6-1 1-2 11 1-6-4-6-3v-2l-4-2-5-3z",
    fill: "#6E71ED"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(734,1059)",
    d: "m0 0 6 1 6 4 14 7 5 5 9 5v2l5 1 4 2 3 3h2l3 3 6 5-3 4-4-1-9-5-5-4-5-2-4-2-1-2h-3l-5-3-3-3 3-1 2 2v-4l-4-2-7-3v-2l-5-2v-2l-6-2v-2l-4-1z",
    fill: "#6E71EC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(708,726)",
    d: "m0 0h2v2h2v2l10 1 1 4 3 1 3 4 5 3 7 3v2l5 1v3l7 1 4 6 4 4-4 1-6-2-7-4v-2h-3l-1-2-2 1-1-4h-4l-1-2-11-5-4-4v-6l-5-1h-3l-2-6z",
    fill: "#6F71EC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(843,207)",
    d: "m0 0 6 2 35 20 12 6 5 4 8 4v2l5 1 6 5-2 1-9-4-3 1-6-1-5-2v-2l-3 1-5-4h2l-1-4h-3l-1-4-5-1-7-5-7-4v-2l-6-2-10-6v-2l-5-2z",
    fill: "#6D8AF3"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(827,360)",
    d: "m0 0 10 3 4 3 12 6 13 8 9 5 8 3v2l4 1 8 4 15 9 6 3v2l6 2 5 3-3 1-12-6-4 1-4-4-7-3-10-6v-2l-4-1-7-3v-2l-5-1-11-7-3-2v-2l-6-2-14-8-10-6z",
    fill: "#6D89F2"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(793,364)",
    d: "m0 0m-1 1 4 2-23 13-21 12-25 14-13 8-17 9-1-2 5-5 12-4 8-5 1-3 10-5 1-2 8-5 1-2 9-1 4-3h2v-2l4-1 8-5 1-2 6-1v-2l11-6z",
    fill: "#7884F2"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(810,412)",
    d: "m0 0 1 2-4 4-7 3-3 4v2l-11 6-13 8-6 2v2l-14 7h-9l5-4 51-30z",
    fill: "#7984F2"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(833,406)",
    d: "m0 0 6 2 17 9 19 11v3l-26 15-18 11h-2v-3l5-1v-2l11-7 3-1 2-3 9-4 7-5v-2h-2v-3l-5-2-10-5-4-3-3-2v-2l-5-2-4-2z",
    fill: "#748FF4"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,718)",
    d: "m0 0h2v2h-2l1 3-10 2-3 1-1 2-12 6-7 3-8 4-3 2h-5l-1 3h-3l-5 2-1 2-8 2-15 6-4-2 35-16 39-17z",
    fill: "#AC63F2"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(805,361)",
    d: "m0 0 12 4 14 6 4 2v2l4 1 8 4 4 1v2l5 1 5 7 16 8 10 6 13 8-2 1-22-12-47-26-23-12-3-2z",
    fill: "#7491F5"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,564)",
    d: "m0 0 4 1 2 9v57l-1 59-2 1-1-126z",
    fill: "#A670F5"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(434,518)",
    d: "m0 0 10 4 4-1v2l5 1 11 6 8 4 10 4 7 5 6 2 10 5 11 4 4 2v2l5 1v2l5 1 1 2-9-3-28-13-40-18-19-9z",
    fill: "#AA67F3"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,382)",
    d: "m0 0 2 1-3 7-7 3-13 7-12 7h-2l-1 3-17 8h-2l-1-4 46-26z",
    fill: "#A46BF3"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,258)",
    d: "m0 0 3 1-21 12-26 15-11 7-31 17-1-2h2l2-4 7-4 5-1 3-3 7-5h4l2-4 7-3h4v-2l9-6 7-4 2-1 2 1v-2h2v-2l4-1 2 1v-2l9-6z",
    fill: "#A279F7"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,676)",
    d: "m0 0 11 6 23 13 19 11 3 3-4 1-9-3-5-2-2-3-5-1v-2l-5-1v-2l-10-4v-2l-8-2-8-10z",
    fill: "#A86BF4"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,204)",
    d: "m0 0h2v2l-10 6-4 2-1 2h-5v2l-3 2h-4v2l-5 3v2h-2v2l-12 7-6 2v2l-6 3-4-1-8 5-7 3-4 2-3-1 25-14 24-14 26-15z",
    fill: "#AC63F2"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(907,843)",
    d: "m0 0 4 2v2l5-1-4 4-14 8-24 12-22 12-3-1 6-4h3v-2l6-3h2l1-3 10-4 5-4 7-3 5-2v-3l5-2-3-2 3-3 7-2z",
    fill: "#6D89F2"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(794,318)",
    d: "m0 0h2l-2 4h-2v2h-2l-1 3-3 2h-3l-1 5-5 1v2l-7 3-6 3-3 3-7 3-3 2-3-1 6-5h2v-3l5-2h3l-4-2 5-4 10-6 6-3h2v-2l7-2v-2z",
    fill: "#6E71ED"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(707,1056)",
    d: "m0 0 5 1 20 10v2l5 2 23 13 10 7 28 14 5 2v4l4-1-3 3-7-4-23-13-52-30-15-9z",
    fill: "#9699FC"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(895,844)",
    d: "m0 0 2 1-2 3h-4v2l-2 1 2 2-17 8-4 2-1 1h-5l-1 4-13 7-9 2-3 3h-6l5-4 22-12 27-15z",
    fill: "#728EF4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(430,358)",
    d: "m0 0 2 1-2 4-9 6-4 2h-3l-1 3-4 1-4 2-2-1v2l-3 2h-3v2l-3 2-8 2-1 86h-1v-87l10-6 24-14z",
    fill: "#A576F6"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(579,492)",
    d: "m0 0 2 4v50l10-2-5 6-7 2v-2h-2l1-11h1v-5l-2-3-1-8 1-9-1-6v-15l3 1z",
    fill: "#8363E8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(755,339)",
    d: "m0 0 3 1-23 12-19 11-8 3v-2l-4-1 24-14 9-5 12-2z",
    fill: "#7174EE"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(558,446)",
    d: "m0 0 2 1-3 5-8 5-7 2v2l-3 2-1 7-1 23-1 8v11l-1 2-2-1 1-53z",
    fill: "#A76FF5"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(533,691)",
    d: "m0 0 2 4-3 1-1 2-12 6h-3l-1 2-8 2-4 3-5 2-2 1-1-1-3 2-2 1h-7v3l-4 1-2-1v-2l21-10 30-13z",
    fill: "#AC64F3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(801,185)",
    d: "m0 0h6l5 2 1 2 12 6 11 6 6 4-3 1-6-3-6-2-16-9-7-2h-6l-4 3-5 2-8 5-19 9-1-2 8-4h3v-2l12-6 12-8z",
    fill: "#707EEF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1216,381)",
    d: "m0 0 6 3 2 2v190h-1l-1-180-1-9-5-4z",
    fill: "#82D9FE"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(830,213)",
    d: "m0 0 7 2 13 8 21 12 9 5 10 6 11 6 9 6 11 6 14 8 2 3-5-2-16-9-24-14-28-16-26-15-8-5z",
    fill: "#90B2FE"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(894,195)",
    d: "m0 0 10 5 23 13 17 10 5 4-4 1v-2h-3v-2h-6l-9-5v-2l-5-2-1-2-7-2-11-6-4-2v-2l-4-2z",
    fill: "#90ACFE"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(818,206)",
    d: "m0 0 10 3 13 6 6 3 2 2 5 2 2 2h3v2l4 1v2l3-1 5 3v2l3-1 4 2 1 2 8 3v2l-6 1-8-5-20-11-9-6-12-6-7-3-7-4z",
    fill: "#6D8AF3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(685,878)",
    d: "m0 0 6 2 7 3 7 5 9 3 3 3 4 2h2v2h3v2h5v2l4 1 7 4 5 3 7 2 1 4-10-3-10-6-11-6-14-7-9-5-9-6-7-4z",
    fill: "#6F75ED"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,891)",
    d: "m0 0 7 1 10 6 12 6 14 8 3 1v2l5 2 12 7 8 6-2 1-25-14-24-14-20-11z",
    fill: "#9890FB"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(908,364)",
    d: "m0 0 5 2 19 10 22 12 5 4h-7l-10-6-7-3-6-3-10-6-7-4v-2h-3z",
    fill: "#8FA8FE"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(615,949)",
    d: "m0 0 12 6 24 14 26 15 5 3-4 1v-2l-4 1v-2l-4-1-4-2v-2l-4-1-12-7-11-6-6-3-4-3-7-4-3-2v-2l-4-1z",
    fill: "#988EFB"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(681,712)",
    d: "m0 0 4 1 2 3 4 1 2 1v2l4 1 1 2 5 1 3 1 4 8h3 5l-1 5-2 1v-2l-6-2-11-6-4-2-5-5-4-2v-2h-2l-4-4z",
    fill: "#7D64E7"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(832,808)",
    d: "m0 0h4l3 3 5 1v2h6l-1 3h3l2 3h4l2 1-1 4-4 3-5 2-7 3-8 4-6-2v-1h8v-2l8-3 4-2 1-4-5-5-5-3v-2l-4-1-4-2z",
    fill: "#6E89F2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(747,389)",
    d: "m0 0 1 2-1 4-20 11-13 8-17 9-1-2 5-5 12-4 8-5 1-3 10-5 1-2 8-5 1-2z",
    fill: "#7D7CF2"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,303)",
    d: "m0 0 2 1-3 4h-2v3l-25 14-15 9v-3l7-6 3-2h3v-2l6-1v-2l9-6 6-3 2-2 5-2z",
    fill: "#A966F2"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,976)",
    d: "m0 0 2 1-4 4-6 3-10 7-5 2-6 4-7 3-10 6-12 6-3-1 23-13 24-14z",
    fill: "#8DAAFE"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(818,450)",
    d: "m0 0m-1 1m-2 0 2 2-11 8-5 2-2 2-7 3-10 5-6 4h-4l-1 2-5 1 2-1 1-3h4v-2l3-1 1-2 9-4 3-3 7-3 6-3h3v-2h4v-2z",
    fill: "#707EEF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(682,988)",
    d: "m0 0 5 2 28 16 11 6v3l3 1-4 1-10-5-3-3-6-3v-2l-4-1-13-8-1-3-5-2z",
    fill: "#9A8AFA"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(793,154)",
    d: "m0 0h6l-2 4-3 1-2 4-4 2-3 3-10 6-12 6-2 2-3-1 4-4 12-6 12-7-4 1-5 1 1-3 5-1v-2l7-3z",
    fill: "#6E71ED"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(622,728)",
    d: "m0 0 5 1 14 8 9 6 7 3v2l5 1 25 15 6 4-1 2-48-28-22-13z",
    fill: "#9890FB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(577,977)",
    d: "m0 0 22 11v2l6 2 7 2 2 4 7 2v4l-5-1-4-3-12-6-7-5-12-6-4-3z",
    fill: "#9F60EE"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(524,902)",
    d: "m0 0 5 1 5 2 2 2 4 2 5 3v2l5 1 4 4-3 3-5-2-2 1-2-1v-2l-2-1-5-5-1-2-7-3-3-3z",
    fill: "#A449DD"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(688,829)",
    d: "m0 0 6 2 17 10-4 3 1 3-2 2-4-3v-2l-3 1v-2l-5-2-4-3v-2l3-1-5-5z",
    fill: "#8365E9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(458,559)",
    d: "m0 0h1v138l-3 1 1-4z",
    fill: "#9B8DFB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,733)",
    d: "m0 0 6 2 15 9 14 8-2 4-3-1v-2l-7-1v-3l-5-1-3-3-5-2-6-4-4-4z",
    fill: "#8186F4"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(854,917)",
    d: "m0 0m-1 1m-1 1m-2 0 4 3-26 14-16 9v-3l8-5h2l1-3 8-4h2v-2h4v-2l5-2h3v-2z",
    fill: "#768FF5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(489,377)",
    d: "m0 0h5l-4 3-23 13-17 10-15 9h-2v-2l4-1v-2l8-4h3v-2l4-3 5-2 8-5h3l2-4 7-3 5-3 2 1v-2z",
    fill: "#A96AF4"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(797,199)",
    d: "m0 0 3 2-27 16-35 20-2-1 9-6 19-11 16-9 6-4 3-3 7-3z",
    fill: "#9790FB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(690,766)",
    d: "m0 0 5 1 11 6 1 2h6l2 1v2h2l3 3 7 3 8 5 8 3v2l-7-1-13-7-16-9-10-6-4-1z",
    fill: "#6E73ED"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(693,770)",
    d: "m0 0 5 1 24 13 10 6 11 6 7 5 6 3 2 3-6-2-48-28-11-6z",
    fill: "#969FFC"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(689,997)",
    d: "m0 0h5l9 6 3 1v2l6 2 1 5-2 2-4-3h-2l-1-1-7-4v-2l-3-1-5-5z",
    fill: "#8863E9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(724,849)",
    d: "m0 0 12 6 21 12 2 2-4 2-1-3h-7l-1-2-11-5-1-5-3 1-4-4-4-2z",
    fill: "#8186F4"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(680,542)",
    d: "m0 0 3 1-23 13-24 14-3 1 2-4 10-6 3-1 1-2 6-2 1-2 14-7 3-2h4v-2z",
    fill: "#AA69F4"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,536)",
    d: "m0 0 7 3v1l-5 1-1 99h-1z",
    fill: "#9A8BFB"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,174)",
    d: "m0 0 5 1-5 4-21 12-7 2-2-2 4-1v-2l8-2v-2h4l1-3 5-1v-2z",
    fill: "#6E72ED"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,668)",
    d: "m0 0h1l1 39 3 2v2h3l1 5-8 4h-1z",
    fill: "#A474F6"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(663,1031)",
    d: "m0 0 6 1 17 9 23 14-4 1-23-13-19-11z",
    fill: "#9791FB"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(586,707)",
    d: "m0 0h5l15 8 4 2 3 2v3l5 2 4 4-6-2-22-13-8-5z",
    fill: "#A475F6"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(758,807)",
    d: "m0 0 6 2 10 6 8 5 7 3 8 5 13 8 4 4-6-2-50-30z",
    fill: "#969EFC"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(767,1091)",
    d: "m0 0 6 1 20 11 10 4v4l4-1-3 3-7-4-23-13-7-4z",
    fill: "#979BFC"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,791)",
    d: "m0 0 4 1v2h5v2l12 6 2 4 5 1v2l-3 1v-2h-5v-2h-4v-2l-4-2-6-2-1-3-5-5z",
    fill: "#7F63E7"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(832,1041)",
    d: "m0 0 2 1-3 1-2 5h-2v2l-5 2-3 1-1 2-5 4-6-1-4 1 5-4 16-9z",
    fill: "#7B90F6"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,414)",
    d: "m0 0m-4 1 4 1-3 5-2 2-5 2-5 3-5 2-1-5z",
    fill: "#AA66F3"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,235)",
    d: "m0 0m-1 1m-1 1m5 0 3 1-34 20-2-1 5-4 4-2 4-4 10-7 4-1v2z",
    fill: "#8683F5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(761,167)",
    d: "m0 0 1 3-3 2h-4v2l-8 4h-2v2l-5 2-1 2h-4v2l-3 2h-5v2l-4 2-4-1 18-10 15-9z",
    fill: "#9690FB"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(818,1094)",
    d: "m0 0h2l-1 4-6 4-4 2h-3v2h-7l-4-4 1-3 4 2h3l5-2 8-4z",
    fill: "#6E71ED"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(680,488)",
    d: "m0 0 2 1-7 7h-4l-2 4h-6l-1 4h-5l-1 4-3 1-5-1 5-4 23-13z",
    fill: "#A371F5"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(859,436)",
    d: "m0 0m-1 1m-2 1 4 2-16 9-13 8h-2v-3l5-1v-2l11-7 3-1 2-3z",
    fill: "#7590F5"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(644,289)",
    d: "m0 0 3 1-22 12-14 8-1-2h2l2-4 7-4 5-1 3-3 7-5h5z",
    fill: "#A86CF4"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(879,348)",
    d: "m0 0 16 8 11 6-3 2-5-1-1-2-7-3-8-4v-2l-4-1z",
    fill: "#8EA7FE"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,835)",
    d: "m0 0 5 1 12 7 8 4 9 6 5 1v2h3v2l4 2-2 1-16-9-11-6-17-10z",
    fill: "#AF5FF2"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(489,760)",
    d: "m0 0 4 1-25 11-10 4-3-1 2-2 7-3 8-3 1-2z",
    fill: "#AB65F3"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(657,227)",
    d: "m0 0h2l-2 4-6 1v2l-16 9-6 4-7 3-4 2-3-1 25-14z",
    fill: "#998BFA"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(772,877)",
    d: "m0 0 6 2 19 11 6 3-1 2-4-2-15-6-4-2v-2l-5-2z",
    fill: "#978FFB"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(975,400)",
    d: "m0 0 16 8 20 11-4 1-8-5-5-1-8-4-3-2v-2l-5-1-4-4z",
    fill: "#8BBFFE"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(855,389)",
    d: "m0 0 9 3 16 9 12 7 8 5-2 1-22-12-18-10z",
    fill: "#93B1FE"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(854,868)",
    d: "m0 0 4 1-3 3-5 3-9 2-3 3h-6l5-4 12-7z",
    fill: "#718DF4"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,547)",
    d: "m0 0 10 4 11 5v2l5 1v2l5 1 1 2-9-3-24-11z",
    fill: "#A573F5"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,979)",
    d: "m0 0 5 1 12 7 9 5 10 6 6 3 4 3-1 2-24-14-21-12z",
    fill: "#988FFB"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,204)",
    d: "m0 0h2v2l-10 6-4 2-1 2h-5v2l-3 2h-4v2l-4 2-4-1 26-15z",
    fill: "#988EFB"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(731,401)",
    d: "m0 0 3 1-15 9-22 12-1-2 5-5 12-4 9-6z",
    fill: "#9A89FA"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(693,208)",
    d: "m0 0 1 2-4 4-9 6-12 6-1-3 4-1v-2l7-2v-2h5l2-4z",
    fill: "#AD5FF1"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,534)",
    d: "m0 0h1v12l10-2-5 6-7 2v-2h-2l1-11h1z",
    fill: "#8163E7"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(949,227)",
    d: "m0 0 5 2 23 13-4 1-6-4-5-1-10-6z",
    fill: "#94C2FE"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(693,716)",
    d: "m0 0 4 1 18 10 5 4-2 1-6-2v-2h-2v-2l-4 1v-2l-4-1-3-1-5-5z",
    fill: "#8E8AF8"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(581,818)",
    d: "m0 0 6 2 8 4 7 4 1 2 5 3 1 2-5-2-15-8-7-4z",
    fill: "#9D60EE"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(830,213)",
    d: "m0 0 7 2 13 8 21 12v2l-5-2-23-13-13-8z",
    fill: "#8EA8FE"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(841,379)",
    d: "m0 0h5l4 2 1 2 5 1 3 6-8-2-7-4-1-3z",
    fill: "#6B90F6"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,382)",
    d: "m0 0 2 1-3 7-7 3-3 1-2-2-2-1z",
    fill: "#A373F5"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(748,913)",
    d: "m0 0 11 3v2h3l1 2 4 2v2l5 1 4 4-10-3-9-6-9-5z",
    fill: "#707FEF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(871,857)",
    d: "m0 0 2 1-4 6h-5l-1 4-3 2-9-1 4-3z",
    fill: "#7490F5"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1039,765)",
    d: "m0 0 2 1-4 5-13 5-5 4h-5l3-3z",
    fill: "#3FB5FC"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(462,393)",
    d: "m0 0 4 1-16 9-15 9h-2v-2l4-1v-2l8-4h3v-2l4-3 5-2z",
    fill: "#A86CF4"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(911,995)",
    d: "m0 0h5l-1 2-7 3-10 6-12 6-3-1 23-13z",
    fill: "#8EAAFE"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(843,423)",
    d: "m0 0 1 2 4 1v2l3-1 3 4-1 2-6 1v2h-2l-1 2-3-2 2-4 4-2v-2l-4-1-1-3z",
    fill: "#6E8AF3"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621 1e3)",
    d: "m0 0 6 2 11 6 7 3 2 1v2l4 2 1 2h-3v-2l-6-2-10-6-11-6z",
    fill: "#AF5FF2"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(623,959)",
    d: "m0 0h2v3l3-1 9 6-1 4h-2v-2l-7-2-5-3z",
    fill: "#7E64E7"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(828,881)",
    d: "m0 0 3 2-6 5-12 4-1 2-3-3z",
    fill: "#788EF5"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,891)",
    d: "m0 0 7 1 10 6 12 6 1 2-10-3-20-11z",
    fill: "#988FFB"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(693,770)",
    d: "m0 0 5 1 24 13 6 4-3 1-23-13-9-5z",
    fill: "#9797FC"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(721,782)",
    d: "m0 0 6 2 8 5 8 3v2l-7-1-13-7z",
    fill: "#6F75ED"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,508)",
    d: "m0 0h3v2h-2v2l-3 1-4 4-4-1v3l-4 2-2-2 7-6z",
    fill: "#A96AF4"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(748,489)",
    d: "m0 0h5l-1 3-7 3-10 5-6 2v-2h4v-2l7-4z",
    fill: "#6E71ED"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(938,380)",
    d: "m0 0 16 8 5 4h-7l-10-6v-2l-4-2z",
    fill: "#8ABDFE"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,258)",
    d: "m0 0 3 1-21 12-5 2v-2l6-3 3-3 7-5z",
    fill: "#A27AF7"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(692,423)",
    d: "m0 0 3 1-15 9-13 7h-2v-2l5-3h3v-2l10-4 2-3z",
    fill: "#A474F6"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(806,358)",
    d: "m0 0 10 4v2l2 1-2 1-11-4-6 4h-3l2-5 4 1v-2h4z",
    fill: "#7380F0"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(773,931)",
    d: "m0 0 5 1 10 6 14 8 4 2-4 1-10-6-19-11z",
    fill: "#959EFC"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(767,381)",
    d: "m0 0 3 1-22 12-1-3 8-5h2v-2l4-1z",
    fill: "#838AF5"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(737,344)",
    d: "m0 0h2v2l-16 9-4 1v2l-3 2h-5l3-3z",
    fill: "#9792FB"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1085,909)",
    d: "m0 0h2v2l-11 7-10 6h-3v-2l12-7z",
    fill: "#86CDFF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(688,829)",
    d: "m0 0 6 2 17 10-3 2h-2v-3l-3 1-1-2h-4v-3l-4-1-6-5z",
    fill: "#948CF9"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(707,1056)",
    d: "m0 0 5 1 6 3 12 7 1 3-5-2-19-11z",
    fill: "#9498FC"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(437,470)",
    d: "m0 0 5 1 13 6v2l-6 1-3-2v-3l-3 1-6-5z",
    fill: "#A76FF4"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,640)",
    d: "m0 0 1 2 3 1 1 4-3 3v5l-3 1v-15z",
    fill: "#AE5EF1"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(633,568)",
    d: "m0 0m-2 1h2v3l-21 12v-3l4-3 9-5 3-1z",
    fill: "#AA67F3"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(699,1049)",
    d: "m0 0 5 1 9 4 10 5v2l-11-3-13-8z",
    fill: "#6F75ED"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(633,516)",
    d: "m0 0 2 1-8 7h-4l-1 3-4 1-4-1z",
    fill: "#A671F5"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(793,312)",
    d: "m0 0h2v2l-13 7-2 3-9 3-4 1 3-3z",
    fill: "#8B95FA"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(608,993)",
    d: "m0 0 5 2 1 3 7 2v4l-5-1-4-3-7-4 3-1z",
    fill: "#A35EEE"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(682,711)",
    d: "m0 0 7 1 5 4 6 7h-3v-2l-4-1v-2l-8-1v-4l-3-1z",
    fill: "#AB63F2"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 800)",
    d: "m0 0m-2 1h2v2l-12 7-7 4-2-1 9-7z",
    fill: "#8ABAFE"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,708)",
    d: "m0 0 13 1 2 1v2l-4 1-3 1-8-2z",
    fill: "#8567EA"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(787,477)",
    d: "m0 0m-1 1m-4 1 7 1-5 4-10 6h-2l2-4 3-2h3z",
    fill: "#7B86F3"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(717,1059)",
    d: "m0 0 9 1 3 4h2v2l6 2h2v2l-4 1-3-2v-2l-5-1-9-5z",
    fill: "#6F79EE"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(871,868)",
    d: "m0 0m-4 1h4l-1 3-18 10-3-1 6-4h3v-2l6-3h2z",
    fill: "#6E8AF3"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(975,800)",
    d: "m0 0 2 1-5 3-6 4-6 3-8 5-4-1 23-13z",
    fill: "#8EB6FE"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(669,754)",
    d: "m0 0 8 4 10 6 6 4-1 2-22-13z",
    fill: "#998EFB"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 256)",
    d: "m0 0 11 6 2 2-5 2-5-2-3-6z",
    fill: "#49B7FC"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(873,232)",
    d: "m0 0 5 2 1 2 8 3v2l-6 1-8-5-1-4z",
    fill: "#668BF4"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(871,236)",
    d: "m0 0 6 2 6 4 11 6 2 2-6-1-19-11z",
    fill: "#8EADFE"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(892,240)",
    d: "m0 0 8 4 5 2 1 3-6-1-5-2v-2l-3 1-2-4z",
    fill: "#717EEF"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(487,712)",
    d: "m0 0 8 1-3 2-2 1h-7v3l-4 1-2-1v-2z",
    fill: "#AD62F2"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(413,540)",
    d: "m0 0h7l9 4v2l-12-2-5-1z",
    fill: "#AC64F3"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(402,374)",
    d: "m0 0 2 1-1 3-3 2h-3v2l-3 2h-5l1-3z",
    fill: "#AB66F2"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(716,193)",
    d: "m0 0 1 2h-2v3l-3 2h-5v2l-3 2h-5l3-3z",
    fill: "#9690FB"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(876,185)",
    d: "m0 0 5 2 12 7-2 2-5-4-7-1-2-4-2-1z",
    fill: "#90AAFE"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(725,903)",
    d: "m0 0 12 4 5 5 1 2-5-2-13-7z",
    fill: "#939CFC"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(622,728)",
    d: "m0 0 5 1 14 8 2 4-21-12z",
    fill: "#9A92FB"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(657,227)",
    d: "m0 0h2l-2 4-6 1v2l-9 5-2-1 3-3z",
    fill: "#998EFB"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(827,1097)",
    d: "m0 0 3 1-20 11v-3l5-1v-2h2v-2z",
    fill: "#8591F8"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(845,1085)",
    d: "m0 0 4 2-14 8v-3l2-3 5-2z",
    fill: "#7591F5"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(930,1023)",
    d: "m0 0 3 2-9 6h-3v2l-6 1 5-5 5-2 1-2z",
    fill: "#6E8AF3"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(946,816)",
    d: "m0 0 2 1-6 4h-2v2l-7 3-4 2-3-1z",
    fill: "#8DAEFE"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645,561)",
    d: "m0 0h5l-5 4-12 6 2-4z",
    fill: "#A76FF5"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(810,412)",
    d: "m0 0 1 2-4 4-7 3-4 3-4-1z",
    fill: "#7D92F7"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(768,926)",
    d: "m0 0 5 1 13 8 3 2-1 2-10-6-6-3z",
    fill: "#6E8AF3"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,920)",
    d: "m0 0 9 2 11 8-2 1-18-10z",
    fill: "#959FFC"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(929,864)",
    d: "m0 0h5l-4 2v2l-5 2-7 4-3-1 3-3 7-3h3z",
    fill: "#6E8AF3"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(895,844)",
    d: "m0 0 2 1-2 3h-4v2l-2 1 2 2-6 2v-4l3-3z",
    fill: "#6F90F5"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(402,750)",
    d: "m0 0 2 1-1 3-10 4-4-2z",
    fill: "#AB66F3"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(708,726)",
    d: "m0 0h2v2h2v2l6 1v2l-5 1-4-1-2-6z",
    fill: "#6E72ED"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(769,490)",
    d: "m0 0 3 1-17 10h-2l1-3 6-4z",
    fill: "#8588F5"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(795,1104)",
    d: "m0 0 8 3v4l4-1-3 3-7-4-2-2z",
    fill: "#8493F7"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1124,383)",
    d: "m0 0 5 1 14 8 2 3-6-2-15-9z",
    fill: "#91D6FE"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(846,1071)",
    d: "m0 0m-1 1m-1 1m-3 1h3v2l-6 2-1 3-5 2-3 2-4-1 11-6 2-2h3z",
    fill: "#6E8AF3"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(603,717)",
    d: "m0 0 5 1 13 8 1 2-6-2-13-8z",
    fill: "#9C90FB"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1069,334)",
    d: "m0 0 6 3 10 6v2l2 1-5-1-9-6-4-2z",
    fill: "#86CDFF"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(918,264)",
    d: "m0 0 5 1 12 7 2 3-5-2-14-8z",
    fill: "#8FB8FE"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,174)",
    d: "m0 0 5 1-5 4-7 1-1-2z",
    fill: "#6F75ED"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(785,153)",
    d: "m0 0v3h-2v2l-4 2h-3v2l-5 2-3-1z",
    fill: "#9693FB"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(928,997)",
    d: "m0 0 3 1-12 8-5-1 8-4 2-2z",
    fill: "#6B8AF3"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(615,949)",
    d: "m0 0 12 6 3 2-1 3-7-4-3-2v-2l-4-1z",
    fill: "#998BFB"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(724,849)",
    d: "m0 0 12 6 3 2-1 2h-4v-3l-3 1-4-4-4-2z",
    fill: "#9790FB"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(918,831)",
    d: "m0 0 2 1-5 4-14 7-2-1z",
    fill: "#8DABFE"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(979,416)",
    d: "m0 0 6 2 12 7-4 1-9-6-5-3z",
    fill: "#8ABDFE"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,410)",
    d: "m0 0 2 1-1 5-7 2-1-4z",
    fill: "#9F6DF2"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(946,280)",
    d: "m0 0 4 1 6 3 9 6 1 2-5-2-15-9z",
    fill: "#8CB9FE"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(818,206)",
    d: "m0 0 10 3 9 5-3 1-9-4-7-4z",
    fill: "#7F92F7"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(718,192)",
    d: "m0 0h4l-1 5-6 3-3-1 3-1v-3h2z",
    fill: "#7076ED"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,817)",
    d: "m0 0 14 7 3 2-1 2-6-2v-2l-4-1-7-4z",
    fill: "#948BF9"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(680,542)",
    d: "m0 0 3 1-16 9h-2v-2l8-5h4v-2z",
    fill: "#A76EF5"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(963,965)",
    d: "m0 0 2 1-8 6-5 2-3 2-3-1z",
    fill: "#8CB7FE"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(685,878)",
    d: "m0 0 6 2 7 3 3 3-1 2-7-4-8-5z",
    fill: "#6E72ED"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(715,844)",
    d: "m0 0 8 4 1 3 6 3-4 1v-2l-4-1-5-4v-2h-2z",
    fill: "#7A82F2"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(649,446)",
    d: "m0 0m-1 1m-3 1h3v3l-5 3-7 1 1-3 7-3z",
    fill: "#AA69F4"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(973,296)",
    d: "m0 0 5 1 6 3 7 5-2 1-16-9z",
    fill: "#8EBDFE"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(985,287)",
    d: "m0 0 4 1 11 7-1 2-14-8z",
    fill: "#8BB7FE"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(830,213)",
    d: "m0 0 7 2 11 7v3l-18-11z",
    fill: "#96A8FD"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(790,890)",
    d: "m0 0 8 2 4 2 7-2-2 4h-8l-9-5z",
    fill: "#728BF4"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(737,395)",
    d: "m0 0m-2 1h2l-2 4-12 6-1-2 10-5 1-2z",
    fill: "#6E72ED"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(689,371)",
    d: "m0 0h2l-1 4-8 3-3 2-3-1 9-6z",
    fill: "#9A8CFA"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1022,324)",
    d: "m0 0 4 1 6 3 9 6-2 1-17-10z",
    fill: "#9ACEFE"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(949,227)",
    d: "m0 0 5 2 5 3 1 4-5-2-5-4z",
    fill: "#90B2FE"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(797,199)",
    d: "m0 0 3 2-10 6-4-1 3-3 7-3z",
    fill: "#8088F4"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(930,1036)",
    d: "m0 0 4 2-11 7-2-1 5-5z",
    fill: "#7C9AF8"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(921,882)",
    d: "m0 0h5l-4 3-10 5 2-4z",
    fill: "#7997F7"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,796)",
    d: "m0 0 8 5 6 3 2 3-6-2-10-6z",
    fill: "#9597FC"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,745)",
    d: "m0 0 9 3 1 3 2 1-3 1-2-2-6-2z",
    fill: "#AB65F3"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,705)",
    d: "m0 0 10 6v2l-9-3-3-2 1-2z",
    fill: "#7E64E7"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(623,301)",
    d: "m0 0 2 1-14 8-1-2h2l2-4z",
    fill: "#A17BF7"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,1067)",
    d: "m0 0h2v2l5 2 7 4-4 1-9-5z",
    fill: "#9791FB"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(695,1047)",
    d: "m0 0 14 8-4 1-10-6z",
    fill: "#9A96FB"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,712)",
    d: "m0 0 6 2 5 3 3 2-1 2-10-5-3-2z",
    fill: "#AD5FF1"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(649,284)",
    d: "m0 0 3 1-4 4-9 3 3-5z",
    fill: "#AE60F2"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(988,965)",
    d: "m0 0 3 1-9 6-6 3-2-1 13-8z",
    fill: "#8ABFFF"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,801)",
    d: "m0 0 12 6 3 3-5-1-11-6z",
    fill: "#998CFB"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1063,448)",
    d: "m0 0 15 8 2 2-5-1-5-3-6-2z",
    fill: "#95D9FE"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(816,314)",
    d: "m0 0 6 2 4 3-5 2-4-4z",
    fill: "#7C91F5"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645,236)",
    d: "m0 0 3 1-1 3-6 3-3-1v-2z",
    fill: "#9B60ED"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(799,830)",
    d: "m0 0 5 2 10 7-2 1-13-8z",
    fill: "#949BFC"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(748,459)",
    d: "m0 0h3l-1 3-4 2-1 2-4-1 1-3z",
    fill: "#6E70EC"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(563,281)",
    d: "m0 0 2 1-5 6h-2v2l-2-1-1-3z",
    fill: "#AA67F3"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,976)",
    d: "m0 0 2 1-4 4-6 3-4-1z",
    fill: "#8DB1FE"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,718)",
    d: "m0 0h2v2h-2l1 3-9 1 4-4z",
    fill: "#AD62F2"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(721,353)",
    d: "m0 0 3 1-2 2h-3v2l-3 2h-5l3-3z",
    fill: "#988FFB"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(644,289)",
    d: "m0 0 3 1-13 7-2-1 5-5 5-1z",
    fill: "#A07DF8"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(678,267)",
    d: "m0 0 2 2-6 2v3l-8 1 4-4 3 1v-2h2v-2z",
    fill: "#AD62F2"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(785,165)",
    d: "m0 0h2v2l-12 7v-3l8-5z",
    fill: "#6F76ED"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,143)",
    d: "m0 0 5 1-2 2-7 2-1 2-3-1 5-4z",
    fill: "#8393F7"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(923,988)",
    d: "m0 0 2 1-3 1-2 4-7 1 3-3z",
    fill: "#8DB3FE"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(999,958)",
    d: "m0 0 2 1-3 4-4 2h-6l4-3z",
    fill: "#8BB2FE"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,364)",
    d: "m0 0 2 1-3 3-3 1-2 3-5-1 4-3z",
    fill: "#8C81F5"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(827,197)",
    d: "m0 0 5 2 9 5 1 2-5-1-10-7z",
    fill: "#6E8AF3"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(743,909)",
    d: "m0 0 4 1 7 2 1 4-8-3z",
    fill: "#6E71ED"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(737,905)",
    d: "m0 0 5 2 1 3 4 2h-3l-9-5z",
    fill: "#6F78EE"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,891)",
    d: "m0 0 7 1 5 3 1 3-5-2-8-4z",
    fill: "#939AFC"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(765,796)",
    d: "m0 0 6 2 5 4 2 1-1 2-7-4-5-3z",
    fill: "#717EEF"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,763)",
    d: "m0 0 13 1-3 4-7-2v-2z",
    fill: "#7079EE"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(804,418)",
    d: "m0 0h2l-1 4-4 2-4-1 4-4z",
    fill: "#707EEF"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(705,415)",
    d: "m0 0 1 3-10 5v-2l5-5z",
    fill: "#8681F5"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(950,387)",
    d: "m0 0 6 2 3 3h-7l-5-4z",
    fill: "#8FBBFE"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(472,386)",
    d: "m0 0h3l-1 3-7 4-3-1 4-1 2-4z",
    fill: "#AD62F2"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(835,376)",
    d: "m0 0 5 2 3 1 1 4-6-2-5-4z",
    fill: "#7B97F7"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,198)",
    d: "m0 0h9l3 6-6-2-6-3z",
    fill: "#7B91F6"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(633,516)",
    d: "m0 0 2 1-8 7-3-1 5-5z",
    fill: "#A476F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoNite);
export default __webpack_public_path__ + "static/media/CryptoNite.4a4462cf9c7fc9b696d145e754e8e41f.svg";
export { ForwardRef as ReactComponent };